export const recipts = [{
  name: 'วีแกนมัทฉะเชค',
  prev: 'bananen_shake.jpg',
  time: '10 min.',
  ingredients: [
    '½ l นมอัลมอนด์',
    'กล้วยสุกหนึ่งลูก',
    'อินทผาลัมสองลูก',
    'เมล็ดเชีย 1 ช้อนชา',
    'ผงมัทฉะ 1.5 ช้อนชา',
    'น้ำมะนาว ½ ช้อนชา'
  ],
  preparation: [
    'ปอกกล้วยแล้วผสมให้เข้ากันกับนมอัลมอนด์ อินทผาลัม เมล็ดเชีย และผงมัทฉะในภาชนะขนาดใหญ่ คลุกเคล้าให้เข้ากันหรือบดให้ละเอียด',
    'เทลงในแก้ว เทน้ำมะนาวเข้าไปแล้วคน แล้วเสริ์ฟ'
  ],
  portions: 1,
  tags: [ 'Wachmacher', 'Snacks', 'Drink', 'Vegan' ]
} ,
{
  name: 'ซุปมะเขือเทศวีแกน',
  prev: 'vegan_tomaten_suppe.jpg',
  time: '30 min.',
  ingredients: [
    'หัวหอม ½ ลูก',
    'กระเทียมสับละเอียด 1 หน่วย',
    'พริกขี้หนู 1 เม็ด',
    'ส้มสองลูก (ยังไม่บีบ)',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    'ซอสมะเขือเทศเข้มข้น 2 ช้อนชา',
    'มะเขือแทศปลอกเปลือก 1 กระป๋องเล็ก (150 กรัม)',
    'น้ำเกลือ 200 มล.',
    undefined
  ],
  preparation: [
    'ปอกเปลือกและสับหัวหอมกับกระเทียมให้ละเอียด ล้างพริกขี้หนูแล้วสับให้เป็นวง ปอกเปลือกส้มและบีบออกประมาณ 120 มล. วางเปลือกส้มครึ่งลูกไว้ข้าง ๆ',
    'เปิดไฟอุ่นน้ำมันมะกอกให้ร้อนในกระทะ ใส่หัวหอม กระเทียม และพริกขี้หนูลงในกระทะ ทอดไปสักพักแล้วใส่ซอสมะเขือเทศเข้มข้น พอผ่านไปสักพัก ใส่น้ำส้มและใส่ส้มครึ่งลูกลงไปในกระทะ ปล่อยให้เดือด',
    'สะเด็ดน้ำมะเขือเทศแล้วใส่ในกระทะพร้อมกับน้ำเกลือ นำไปต้มและปรุงที่ความร้อนปานกลางเป็นเวลา 15-20 นาที',
    'นำเปลือกส้มออกจากน้ำซุป เคี่ยวน้ำซุปอย่างประณีต ปรุงรสด้วยเกลือ พริกไทย และสมุนไพร'
  ],
  portions: 2,
  tags: [ 'Der Klassiker', 'Lunch', 'Vegan' ]
} ,
{
  name: 'ซุปถั่วมะพร้าวร้อน',
  prev: 'scharfe_kokos_linsensuppe_vegan.jpg',
  time: '25 min.',
  ingredients: [
    'ขิงหนึ่งชิ้น (ขนาดเท่าลูกเฮเซลนัท)',
    'หัวหอม 1 ลูก',
    'กะทิ 300 มล.',
    'น้ำเปล่า 150 มล.',
    'ถั่วแดง 100 กรัม',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    'มะเขือเทศสับ 1 กระป๋อง (200 กรัม)',
    'มะนาว ½ ลูก',
    undefined
  ],
  preparation: [
    'ปอกเปลือกหัวหอมกับขิงแล้วหั่นเป็นชิ้นเล็ก ๆ ต้มน้ำในกาน้ำ',
    'อุ่นน้ำมันมะกอกในกระทะก้นลึก ใส่ขิง หัวหอม และถั่วลงไป อบสักพัก.',
    'เพิ่มกะทิ น้ำต้ม และชิ้นมะเขือแทศลงไปในกระทะ ปรุงรสด้วยผงพริก ปล่อยให้เดือดกรุ่น ๆ เป็นเวลา 10 นาที',
    'ปรุงรสด้วยเกลือ พริกไทย และน้ำมะนาว'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch', 'Vegan' ]
} ,
{
  name: 'ซุปแครอทขิงวีแกน',
  prev: 'vegane_ingwer_karotten_suppe.jpg',
  time: '30 min.',
  ingredients: [
    'หัวหอม 1 ลูก',
    'แครอท 300 กรัม',
    'น้ำเกลือ 100 มล.',
    'ขิงหนึ่งชิ้น (ขนาดเท่าลูกเฮเซลนัท)',
    undefined,
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ปอกเปลือกและสับหัวหอมกับขิงอย่างละเอียด ล้าง ปอก และหั่นแครอท',
    'อุ่นน้ำมันมะกอกในกระทะ ทอดหัวหอมสักพักจนว่าจะโปร่งใส จากนั้นใส่แครอทและขิง ดีเกลซผักด้วยน้ำเกลือแล้วปล่อยให้เดือดที่ความร้อนปานกลางเป็นเวลา 15-20 นาที',
    'เคี่ยวซุปจนได้ที่แล้วปรุงด้วยเกลือและพริก ล้างและหั่นพาร์สลีย์ โรยด้านบนซุป'
  ],
  portions: 2,
  tags: [ 'Vitaminbombe', 'Lunch', 'Vegan' ]
} ,
{
  name: 'ซุปผักโขมและมะพร้าววีแกน”',
  prev: 'vegane_kokos_spinat_suppe.jpg',
  time: '25 min.',
  ingredients: [
    'กะทิ 200 มล.',
    'ผักชีฝรั่ง 100 กรัม',
    'น้ำ 250 มล.',
    'เม็ดยี่หร่า 100 กรัม',
    'ผักโขม 200 กรัม',
    'พริกขี้หนู ½',
    'แคอรท 1 อัน',
    'ขิงหนึ่งชิ้น (ขนาดเท่าลูกเฮเซลนัท)',
    undefined
  ],
  preparation: [
    'ใส่น้ำและกะทิลงในหม้อแล้วต้ม',
    'ล้างและปอกเปลือกยี่หร่ากับชึ้นฉ่ายแล้วหั่นเป็นชิ้นเล็ก ๆ ใส่ผักลงไปในหม้อแล้วทำอาหารด้วยไฟปานกลางเป็นเวลา 10 นาที',
    'ล้างผักโขมแล้วสับ ล้างและปอกแครอทแล้วหั่นเป็นเส้นเล็ก ๆ ปอกเปลือกแล้วหั่นขิง ล้างพริกแล้วหั่นเป็นวง ๆ',
    'เพิ่มส่วนผสมทั้งหมดลงในน้ำซุปและทำอาหารที่ความร้อนต่ำเป็นเวลา 4 นาที ปรุงรสด้วยเกลือและพริก'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch', 'Vegan' ]
} ,
{
  name: 'สลัดถั่วชิคพีและดอกกะหล่ำ',
  prev: 'kichererbsen_blumenkohlsalat_vegan.jpg',
  time: '20 min.',
  ingredients: [
    undefined,
    '1 กระป๋องถั่วชิคพี (น้ำหนักเนื้อ 240 กรัม)',
    'ต้นหอม 2 ต้น',
    undefined,
    'น้ำมันมะกอก 3 ช้อนโต๊ะ',
    'มะนาว ½ ลูก',
    'เครื่องแกง 1 ช้อนชา',
    undefined
  ],
  preparation: [
    'ล้างกะหล่ำดอก หั่นเป็นดอกเล็กแล้วหั่นเป็นชิ้นเล็ก ๆ อุ่นน้ำมันมะกอกในกระทะ ทอดกะหล่ำดอกเป็นเวลา 10 นาทีที่ความร้อนปานกลาง',
    'ล้างชิคพีด้วยน้ำแล้ววางในชาม จากนั้นใส่น้ำมันมะกอก 1 ช้อนโต๊ะ ล้างหัวหอมแล้วหั่นเป็นวงเล็ก ๆ ล้างพาร์สลีย์แล้วหั่นให้ละเอียด ผสมหัวหอมกับพาร์สลีย์เข้าด้วยกันกับชิคพี',
    'บีบมะนาวแล้วเติมน้ำมะนาวลงในชาม ใส่กะหล่ำดอก ปรุงรสด้วยเครื่องแกง เกลือ และพริก ทิ้งไว้ให้เย็นก่อนเสริ์ฟ'
  ],
  portions: 2,
  tags: [ 'Gut vorzubereiten', 'Snacks', 'Vegan' ]
} ,
{
  name: 'แกงไทยพร้อมมันเทศวีแกน',
  prev: 'veganes_thai_curry_suesskartoffeln.png',
  time: '30 min.',
  ingredients: [
    'มันเทศใหญ่ 2 ลูก',
    'บร็อคโคลี่ 1 อัน',
    'ต้นหอม ½ พวง',
    'พริกแดง 1',
    'แครอท 2 อัน',
    'กะทิกระป๋องเล็ก 1 กระป๋อง',
    'มะนาวหนึ่งลูก',
    'ซอสถั่วเหลือง 1 ช้อนโต๊ะ',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างมันฝรั่ง ปอกเปลือกแล้วหั่นเป็นชิ้นเล็ก ๆ',
    'ล้างผักที่เหลือแล้วหั่นเป็นชิ้นเล็ก ๆ บีบมะนาว',
    'อุ่นน้ำมันมะกอกในกระทะ ใส่ชิ้นส่วนแครอท จากนั้นค่อย ๆ เพิ่ม บร็อคโคลี่ พริก และต้นหอมสด ผัดไปสักพัก ปรุงรสด้วยเกลือ พริก และผงกะหรี่',
    'เพิ่มน้ำมะนาว ซอสถั่วเหลือง และกะทิ เพิ่มชิ้นมันฝรั่ง เคี่ยวบนไฟที่อ่อนจนกว่ามันเทศจะสุก จัดเรียงแล้วเสริ์ฟ'
  ],
  portions: 2,
  tags: [ 'Sättigend', 'Lunch', 'Vegan' ]
} ,
{
  name: 'กระทะผักวีแกนพร้อมมันเทศ',
  prev: 'vegane_gemuesepfannesuesskartoffeln.jpg',
  time: '30 min.',
  ingredients: [
    'มันเทศขนาดใหญ่หนึ่งอัน',
    'หัวหอม 1 ลูก',
    'แครอท 3 อัน',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'บร็อคโคลี่ 1 อัน',
    'น้ำเกลือ 300 มล.',
    undefined
  ],
  preparation: [
    'ล้าง ปอกเปลือก และหั่นหัมหอมกับแครอทให้เป็นลูกเต๋า ล้างบรอกโคลี ตัดก้านออก ปอกและหั่นเป็นก้อนสี่เหลี่ยมเล็กๆ ตัดดอกบรอกโคลีออก ล้าง ปอกเปลือก แล้วหั่นมันเทศเป็นลูกเต๋า',
    'อุ่นน้ำมันมะอกในกระทะ ใส่หัวหอมและแครอทลูกเต๋าลงในกระทะแล้วทอด',
    'เพิ่มมันฝรั่งลูกเต๋าแล้วทอดสักพัก จากนั้นเติมน้ำเกลือ เติมชิ้นบรอกโคลี',
    'ปิดฝากระทะแล้วเคี่ยวเป็นเวลา 15 นาทีที่ความร้อนปานกลาง'
  ],
  portions: 2,
  tags: [ 'Ballaststoffreich', 'Lunch', 'Vegan' ]
} ,
{
  name: 'แกงเต้าหู้วีแกน',
  prev: 'veganes_tofu_curry.jpg',
  time: '25 min.',
  ingredients: [
    'เต้าหู้ 300 กรัม',
    'ขิงชิ้นเล็ก 1 ชิ้น (1 ซม.)',
    'ต้นหอม 1 พวง',
    'แครอท 2 อัน',
    'พริกหยวกเหลือง 1 อัน',
    'เม็ดมะม่วงหิมพานต์ 3 ออนซ์',
    'น้ำเกลือ 100 มล.',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ปอกและหั่นขิง ล้างและหั่นแครอท พริก และต้นหอมสด หั่นเม็ดมะม่วงหิมพานต์แบบหยาบ หั่นให้เต้าหู้เป็นลูกเต๋า',
    'อุ่นน้ำมันมะกอกในกระทะ ใส่ชิ้นขิง แครอท และพริกในกระทะแล้วทอด',
    'เพิ่มก้อนเต้าหู้ ปรุงรสส่วนผสมทั้งหมดด้วยเกลือ พริกไทย และผงกะหรี่ ทอดอีกสองนาที',
    'เพิ่มน้ำเกลือ 100 มล. เข้าไปในกระทะ ปล่อยให้เดือด ปรุงรสด้วยเกลือ พริก และเครื่องแกง'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch', 'Vegan' ]
} ,
{
  name: 'ชิลลี่ คอน คาร์เน',
  prev: 'chili_sin_carne.jpg',
  time: '30 min.',
  ingredients: [
    'เต้าหู้ 300 กรัม',
    'หัวหอม 1 ลูก',
    'กระเทียมสับละเอียด 1 หน่วย',
    'พริกแดง 1',
    'เปปเปอโรนีแดง',
    'น้ำซุปข้นมะเขือเทศ 250 มล.',
    'ธัญพืชข้าวโพด 1 กระป๋องเล็ก',
    'ถั่วแดงหลวงหนึ่งกระป๋องเล็ก',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'หั่นเต้าหู้ให้เป็นลูกเต๋า ผสมน้ำมันมะกอก 1 ช้อนโต๊ะเข้ากับผงพริกแล้วใส่ก้อนเต้าหู้ลูกเต๋า',
    'ปอกเปลือกหัวหอมกับกระเทียมแล้วสับให้ละเอียด ล้าง เอาเมล็ดออก แล้วหั่นหยิกหยวกและพริกขี้หนูอย่างละเอียด.',
    'อุ่นน้ำมันมะกอกในกระทะ ผัดเต้าหู้ก้อน เติมเกลือและพริกป่น นำออกจากเตาแล้วปล่อยให้อุ่น ใส่หัวหอม กระเทียม และพริกขี้หนูลงในกระทะอุ่นแล้วทอด ใส่หัวหอม กระเทียม และพริกที่หนูลงในกระทะที่อุ่นแล้วนำไปทอด เพิ่มมะเขือเทศ ปรุงรสด้วยเกลือและพริกไทย เคี่ยวเป็นเวลา 5 นาทีที่ความร้อนปานกลาง',
    'ล้างข้าวโพดและถั่วแดงหลวงแล้วใส่เข้าไปในกระทะ ทอดต่อไปที่ความร้อนปานกลาง เพิ่มก้อนเต้าหู้ ปรุงด้วยเกลือ พริกไทย และพริกป่น'
  ],
  portions: 2,
  tags: [ 'Fleischlose Alternative', 'Lunch', 'Vegan' ]
} ,
{
  name: 'ของเทอเรลล์วีแกน',
  prev: 'vegane_pfifferlingspfanne.jpg',
  time: '30 min.',
  ingredients: [
    'ชองเทอเรลล์ 300 กรัม',
    'หัวหอม 1 ลูก',
    'ต้นหอมจีน 1 พวง',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    'ครีมถั่วเหลือง 150 มล.',
    'มัสตาร์ด 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างแชนเทอเรลล์ ปอกเปลือกหัวหอม หั่นลูกเต๋าให้ละเอียด Wash chives and cut into fine rings',
    'อุ่นน้ำมันมะกอกในกระทะทอด เพิ่มชานเทอเรลล์และทอด เพิ่มชิ้นหัวหอมแล้วทอด ปรุงรสด้วยเกลือและพริกไทย',
    'ใส่ครีมถั่วเหลืองและเคี่ยว',
    'ผัดมัสตาร์ดลงในซอส ปรุงด้วยเกลือและพริกไทย เพิ่มกระเทียมแล้วผัด'
  ],
  portions: 2,
  tags: [ 'Ballaststoffreich', 'Lunch', 'Vegan' ]
} ,
{
  name: 'ผักควินัวทอดวีแกน',
  prev: 'vegane_quinoa_gemuese_pfanne.jpg',
  time: '30 min.',
  ingredients: [
    'บร็อคโคลี่ 250 กรัม',
    'พริกแดง 1',
    'กระเทียมสับละเอียด 1 หน่วย',
    'แคอรท 1 อัน',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    'ถั่ว 75 กรัม (จากช่องแช่แข็ง)',
    'น้ำเกลือ 200 มล.',
    'ควินัว 100 กรัม',
    undefined
  ],
  preparation: [
    'ล้างบร็อคโคลี่ ตัดก้าน ปอกเปลือกแล้วหั่นเป็นดอกย่อย จากนั้นหั่นดอกย่อยเป็นชิ้นเล็ก ๆ',
    'ล้างและเอาเมล็ดของพริกออก แล้วหั่นเป็นก้อนเล็ก ล้างและปอกแครอทแล้วหั่นเป็นแผ่นเล็ก ๆ ปอกเปลือกกระเทียมสับละเอียด',
    'ล้างควินัวในตะแกรงด้วยน้ำ ต้มน้ำประมาณ 400 มล. ในหม้อ เพิ่มควินัว เคี่ยวเป็นเวลา 12 นาที นำออกจากความร้อน เพิ่มเกลือแล้วปล่อยให้บวมอีก 10 นาที',
    'อุ่นน้ำมันมะกอกในกระทะ เพิ่มพริก บร็อคโคลี่ แครอท และกระเทียมลงไปในกระทะแล้วทอดในความร้อนปานกลางเป็นเวลา 5 นาที เพิ่มถั่ว ปรุงรสด้วยเครื่องแกง เกลือ และพริกไทย',
    'เพิ่มน้ำเกลือ ปล่อยให้เดือด ใส่ควินัวและปรุงอาหารเป็นเวลา 5 นาที'
  ],
  portions: 2,
  tags: [ 'Nährstoffreich', 'Lunch', 'Vegan' ]
} ,
{
  name: 'ถั่วกับครีมถั่วเหลือง',
  prev: 'bohnen_soja.jpg',
  time: '30 min.',
  ingredients: [
    'ถั่วปากอ้า 200 กรัม',
    'หัวหอม 1 ลูก',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'ถั่วกระป๋อง 150 กรัม',
    'ก้านขึ้นฉ่ายสองต้น',
    'น้ำมะนาว 1 ช้อนโต๊ะ',
    'ครีมถั่วเหลือง 100 มล.',
    undefined
  ],
  preparation: [
    'ล้างถั่ว (ขึ้นอยู่กับรสนิยม สามารถปอกผิวหนังออกได้ โดยใส่ถั่วในน้ำเดือดแล้วปอกหนังออก) ทำให้ถั่วสะเด็ดน้ำ',
    'ล้าง ปอกเปลือก และสับผักชีฝรั่ง ปอกเปลือกต้นหอมและสับ',
    'อุ่นน้ำมันมะกอกในกระทะ เพิ่มผักชีฝรั่งและหัวหอม ผัดไปสักพัก เพิ่มถั่วแล้วปรุงต่อประมาณ 1 นาที',
    'เพิ่มน้ำมะนาวแล้วต้ม เพิ่มครีมถั่วเหลือง ปล่อยให้มันเดือดสักพัก ปล่อยให้เคี้ยวเป็นเวลา 5 นาทีที่ความร้อนปานกลาง',
    'จัดเรียงด้วยสมุนไพรตามที่ชอบแล้วเสิร์ฟ'
  ],
  portions: 2,
  tags: [ 'Leicht', 'Lunch', 'Vegan' ]
} ,
{
  name: 'เต้าหู้ผักวีแกน',
  prev: 'vegane_tofu_gemuese_pfanne.jpg',
  time: '35 min.',
  ingredients: [
    'กระเทียมต้นหนึ่งต้น',
    'ผักโขม 80 กรัม',
    'เต้าหู้ 200 กรัม',
    'หนึ่งพริกไทย',
    'แครอท 350 กรัม',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'น้ำเปล่า 150 มล.',
    'พาร์สลีย์ ½ พวง',
    'มะนาว ½ ลูก',
    undefined
  ],
  preparation: [
    'เพิ่มเกลือลงไปในน้ำในหม้อ เพิ่มผักโขมแล้วต้ม ปล่อยให้ผักโขมบวมเป็นเวลา 20 นาทีที่ความร้อนต่ำ',
    'ปอกเปลือกแล้วสไลซ์แครอทเป็นแผ่น ล้างต้นหอมและหั่นเป็นวง ล้างมะนาวแล้วขูดเปลือก ตัดเต้าหู้เป็นเส้น ล้างและหั่นพาร์สลีย์ ล้างเอาเมล็ดออกแล้วสับพริก',
    'อุ่นน้ำมันมะกอกในกระทะ ผัดเต้าหู้ เพิ่มกระเทียมต้นแล้วผัด จากนั้นใส่แครอทลงไปผัดอีกสักครู่ เพิ่มผักโขมด้วยน้ำเล็กน้อยแล้วปรุงเป็นเวลา 5 นาที',
    'ผสมในพาร์สลีย์ ปรุงรสด้วยเกลือ พริกไทย และผิวเลมอน'
  ],
  portions: 2,
  tags: [ 'Mit Amaranth', 'Lunch', 'Vegan' ]
} ,
{
  name: 'แกงสตูว์วีแกน',
  prev: 'veganer_curry_eintopf.jpg',
  time: '35 min.',
  ingredients: [
    'กระเทียมต้น ½ ต้น’',
    'มันเทศขนาดใหญ่หนึ่งอัน',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    'ถั่ว 100 กรัม',
    'ซอสมะเขือเทศเข้มข้น 1TL',
    'น้ำเปล่า 200 มล.',
    undefined
  ],
  preparation: [
    'ล้างกระเทียมต้น หั่นเป็นวง ๆล้างมันเทศปอกเปลือกและสับมันเทศ',
    'อุ่นน้ำมันมะกอกในกระทะ ทอดกระเทียมต้น มันเทศ และเลนทิล เพิ่มซอสมะเขือเทศเข้มข้น ปรุงด้วยเครื่องแกงและดีเกลซด้วยน้ำ ปรุงรสด้วยเกลือและพริกไทย เคี่ยวเป็นเวลา 15 นาที กวนเป็นครั้งคราว',
    'ปรุงรสอีกครั้งด้วยเกลือ พริกไทย และเครื่องแกง จัดเรียงกับสมุนไพรตามที่ชอบแล้วเสิร์ฟ'
  ],
  portions: 2,
  tags: [ 'Sättigend', 'Lunch', 'Vegan' ]
} ,
{
  name: 'แครอทแอปริคอตกะหรี่',
  prev: 'karotten_aprikosen_curry.jpg',
  time: '30 min.',
  ingredients: [
    'เต้าหู้ 200 กรัม',
    'หัวหอมใหญ่ 1 หัว',
    'แครอท 300 กรัม',
    'แอปริคอต 100 กรัม (อัดกระป๋อง)',
    'กระเทียมสับละเอียด 1 หน่วย',
    'กะทิ 100 มล.',
    'น้ำเปล่า 75 มล.',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'พริกขี้หนู 1 เม็ด',
    undefined
  ],
  preparation: [
    'หั่นเต้าหู้เป็นเส้น ตัดแอปริคอตเป็นก้อนแล้วเก็บน้ำไว้ในกระป๋อง ปอกหัวหอม แครอท และกระเทียมแล้วหั่นเป็นชิ้นเล็ก ๆ ล้างพริกขี้หนู หั่นเป็นวง ๆ',
    'อุ่นน้ำมันมะกอกในกระทะ ทอดเส้นเต้าหู้ที่ความร้อนต่ำทุกด้าน ปรุงรสด้วยเกลือและพริกไทย เอาออกแล้วปล่อยให้อุ่น',
    'เพิ่มชิ้นส่วนกระเทียมและหัวหอมลงในกระทะแล้วผัด จากนั้นใส่ชิ้นแครอทลงไปผัดให้สั้น ปรุงรสด้วยน้ำแกงและดีเกลซด้วยน้ำ.',
    'เพิ่มชิ้นส่วนแอพริคอทและน้ำ พริกที่หั่นเป็นวง กะทิ ปรุงรสด้วยเกลือและพริกไทย เพิ่มเต้าหู้แล้วปล่อยให้แห้งเป็นเวลา 10 นาที'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch', 'Vegan' ]
} ,
{
  name: 'ชิลลี่ คอน คาร์เน',
  prev: 'chili_con_carne.jpg',
  time: '25 min.',
  ingredients: [
    'เนื้อวัวบด 300 กรัม',
    'พริกขี้หนู 1 เม็ด',
    'หัวหอม 1 ลูก',
    'กานพลู ½  ',
    'มะเขือเทศ 1 กระป๋อง',
    'ผงพริก 1 ช้อนชา',
    'ถั่วแดงหลวง 1 กระป๋อง (250 กรัม)',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ปอกกลีบกระเทียมและหัวหอมแล้วหั่นเป็นก้อนเล็ก ๆ อุ่นน้ำมันมะกอกในกระทะ ผัดหัวหอมและกระเทียมเป็นเวลา 5 นาที',
    'ล้างและสับพริกขี้หนู ใส่ในกระทะด้วยผงพริก ผัดประมาณสองนาที.',
    'เพิ่มเนื้อสับแล้วผัด ผัดในมะเขือเทศและถั่วแดงหลวง ปรุงรสด้วยเกลือและพริกไทย',
    'เคี่ยวบนไฟร้อนปานกลางประมาณ 90 นาที'
  ],
  portions: 2,
  tags: [ 'Gut vorzubereiten', 'Lunch' ]
} ,
{
  name: 'เนื้อวัวผัดพริกไทย',
  prev: 'rindfleisch_paprika.png',
  time: '20 min.',
  ingredients: [
    'เนื้อสเต็กสองชิ้น',
    'หัวหอม 1 ลูก',
    'หนึ่งพริกไทย',
    'เปปเปอโรนีหนึ่ง',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    undefined,
    undefined
  ],
  preparation: [
    'ล้างพริกและเปปเปอร์โรนี เอาเมล็ดออกแล้วหั่นเป็นเส้น ปอกหัวหอมและตัดเป็นวง ตัดเนื้อเป็นเส้น',
    'อุ่นน้ำมันมะกอกในกระทะ ทอดเส้นเนื้อและปรุงรสด้วยเกลือและพริกไทย เพิ่มเปปเปอร์โรนี หัวหอม และพริกขี้หนู ผัดไปสักพัก',
    'ปรุงตามที่ต้องการด้วยซอสถั่วเหลืองแล้วเสิร์ฟ'
  ],
  portions: 2,
  tags: [ 'Deftig', 'Lunch' ]
} ,
{
  name: 'มันเทศอบ',
  prev: 'suesskartoffelspalten.jpg',
  time: '30 min.',
  ingredients: [
    'มันเทศ 3-4 ชิ้น',
    'สามกระเทียมสับละเอียด',
    undefined,
    'น้ำมันมะกอก 3 ช้อนโต๊ะ',
    'เต้าหู้สมุนไพรไขมันต่ำ 3 ช้อนโต๊ะ'
  ],
  preparation: [
    'ล้างมันฝรั่งแล้วหั่นให้เป็นชิ้นเท่า ๆ กัน เกลี่ยให้ทั่วบนถาดอบที่มีกระดาษรองอบ',
    'เปิดเตาอบที่ 200 องศา ปอกเปลือกกระเทียมและหั่นเป็นชิ้นเล็ก ๆ ผสมกับน้ำมันมะกอก และปรุงรสด้วยเกลือพริกไทยและผงปาปริก้า',
    'กระจายส่วนผสมกระเทียมและเครื่องเทศอย่างสม่ำเสมอบนเวดจ์มันฝรั่ง นำเข้าอบประมาณ 15-20 นาที',
    'จัดแต่งมันฝรั่งด้วยนมเปรี้ยวสมุนไพรแล้วเสิร์ฟ'
  ],
  portions: 2,
  tags: [ 'Gesunde Alternative', 'Lunch', 'Snacks' ]
} ,
{
  name: 'Redfish บนชานเทอเรลล์',
  prev: 'rotbarsch_auf_pfifferlingen.jpg',
  time: '30 min.',
  ingredients: [
    'Redfish สองตัวครึ่ง (300 กรัม)',
    'หัวหอม ½ ลูก',
    'แชนเทอเรลล์ 150 กรัม (สดหรือแช่แข็ง)',
    'ต้นหอม ½ พวง',
    'มะเขือเทศเล็ก 200 กรัม',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    'น้ำมะนาว 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างปลาและถอนกระดูกหากจำเป็น',
    'พรำเนื้อด้วยน้ำเลมอนและปรุงรสด้วยเกลือ',
    'ปอกหัวหอม หั่นเป็นชิ้นเล็ก ๆ ล้างต้นหอมสดแล้วหั่นเป็นวง ล้านชานเทอเรลล์',
    'ล้างมะเขือเทศ ใส่น้ำร้อนจากกาต้มน้ำลงในชาม หั่นเป็นชิ้นเล็ก ๆ ในมะเขือเทศแล้วใส่ในน้ำร้อน หลังจากผ่านไปสองสามนาทีให้นำออกมาและนำผิวหนังออก',
    'ใส่น้ำมันมะกอกลงในกระทะแล้วทำให้ร้อน เพิ่มชิ้นหัวหอมและทอดจนโปร่งใส จากนั้นใส่ชานเทอเรลล์แล้วผัดประมาณ 8 นาที',
    'พิ่มต้นหอมสดและมะเขือเทศลงไปในชานเทอเรลล์ ปล่อยให้เข้ากันประมาณ 3 นาที จากนั้นปรุงรสด้วยเกลือและพริกไทย',
    'ในอีกกระทะให้ทอดเนื้อปลาในน้ำมันมะกอกประมาณ นาทีสำหรับทั้งสองด้าน'
  ],
  portions: 2,
  tags: [ 'Proteinreich', 'Lunch' ]
} ,
{
  name: 'ชิลลี่ คอน คาร์เน',
  prev: 'chili_con_carne_omelette.jpg',
  time: '30 min.',
  ingredients: [
    'ไข่ 4 ฟอง',
    'หัวหอม 1 ลูก',
    'กระเทียมสับละเอียด 1 หน่วย',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    'พริกแดง 1',
    'มะเขือเทศ 1 กระป๋อง',
    'เนื้อวัวบด 250 กรัม',
    'พริกขี้หนู 1 เม็ด',
    'ผงพริก 1 ช้อนชา',
    'ถั่วแดงหลวง 1 กระป๋อง (250 กรัม)',
    undefined
  ],
  preparation: [
    'ปอกหัวหอมและกลีบกระเทียมแล้วสับเป็นชิ้นเล็ก ๆ ล้างพริกขี้หนูแล้วหั่นเป็นวงเล็ก ๆ',
    'อุ่นน้ำมันมะกอกในกระทะแล้วทอดเนื้อสับ เพิ่มพริก หัวหอม กระเทียม และพริกขี้หนูแล้วทอดเป็นเวลา 2 นาที',
    'เพิ่มมะเขือเทศกระป๋องและถั่วแดงหลวง ปรุงรสด้วยเกลือ พริกไทย และพริกป่น ผัดแล้วเคี่ยวสองถึงสามนาที',
    'ในขณะเดียวกันให้ใส่น้ำมันมะกอกในกระทะที่สอง ผัดไข่ 2 ฟองผ่านความร้อนต่ำเพื่อทำไข่เจียว ปรุงรสไข่ดิบด้วยเกลือและพริกไทย กลับด้านไข่เจียวอย่างระมัดระวังและนำออกจากกระทะ ทำไข่เจียวตัวที่สองด้วยวิธีเดียวกัน.',
    'ใส่พริกพริกไทยลงในไข่เจียวและปิด'
  ],
  portions: 2,
  tags: [ 'Low Carb', 'Breakfast', 'Lunch', 'Dinner', 'Snacks' ]
} ,
{
  name: 'คูสคูศยัดไส้พริกกับเฟตา',
  prev: 'couscous_paprika_mit_feta.jpg',
  time: '30 min.',
  ingredients: [
    '2 พริกขี้หนู',
    'คูสคูสดิบ 100 กรัม',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'เฟตาชีส 100 กรัม',
    'มะกอก 50 กรัม (มีหลุม)',
    'มะเขือเทศเชอรี่สามลูก',
    undefined
  ],
  preparation: [
    'เอาเมล็ดออกแล้วล้างพริกครึ่งหนึ่ง',
    'ต้มน้ำเกลือในหม้อ นำหม้อออกจากความร้อนและเพิ่มคูสคูสในระหว่างผัด ปิดฝาแล้วปล่อยให้บวมเป็นเวลา 5 นาทีที่ความร้อนต่ำ',
    'หั่นชีสเฟตาเป็นลูกเต๋า ล้างมะกอกและหั่นเป็นชิ้นเล็กชิ้นน้อย ล้างมะเขือเทศและหั่นเป็นชิ้นเล็ก ๆ ผสมชีสมะกอกและมะเขือเทศกับคูสคูส ปรุงรสด้วยเกลือ พริกไทย และใบโหระพา',
    'เปิดเตาอบที่อุณหภูมิ 200 องศาเซลเซียส เติมพริกกับส่วนผสมคูสคูสเฟตา ใส่ในเตาอบและอบประมาณ 20 นาที'
  ],
  portions: 2,
  tags: [ 'Gut vorzubereiten', 'Lunch' ]
} ,
{
  name: 'หมูบ่มในซอสมัสตาร์ดแอปเปิ้ล',
  prev: 'kasseler_apfel.jpg',
  time: '30 min.',
  ingredients: [
    'หมูไร้กระดูกสองชิ้น',
    'แอปเปิลสองลูก',
    'ซุปผัก 100 มล.',
    'น้ำเลมอน 2 ช้อนชา',
    'มัสตาร์ด 2 ช้อนชา',
    undefined
  ],
  preparation: [
    'ล้างและปอกแอปเปิ้ลแล้วหั่นเป็นก้อนเล็ก ๆ จากนั้นโรยด้วยน้ำมะนาว',
    'ตั้งกระทะด้วยน้ำมันมะกอก และทอดแต่ละด้านประมาณ 3 นาที เพิ่มแอปเปิ้ลที่หั่นเป็นสี่เหลี่ยมลูกเต๋า และทอดที่ความร้อนต่ำอีก 7 นาที ปรุงรสด้วยเกลือและพริกไทย',
    'นำชิ้นส่วนของไส้กรอกออกจากกระทะและอุ่น ดีเกลซแอปเปิ้ลก้อนกับน้ำสต๊อก ผัดในมัสตาร์ด และถ้าจำเป็น ปรุงรสอีกครั้งด้วยเกลือและพริกไทย วางหมูที่รมควันในกระทะแล้วรอเคี่ยวประมาณ 10 นาที',
    'เสิร์ฟและเพลิดเพลิน'
  ],
  portions: 2,
  tags: [ 'Deftig', 'Lunch' ]
} ,
{
  name: 'แซลมอนบนซอสซาวอย',
  prev: 'lachs_bohnen.jpg',
  time: '30 min.',
  ingredients: [
    'กะหล่ำปลีใบย่น 350 กรัม',
    'ครีมไขมันต่ำ 4 ช้อนโต๊ะ',
    'เนื้อแซลมอนไร้หนัง 300 กรัม',
    'น้ำมันมะกอก 2 ช้อนชา',
    '1 สไลซ์เลมอน',
    'นมไขมันต่ำ 50 มล.',
    'ผักชีลาวหนึ่งช้อนชา',
    undefined
  ],
  preparation: [
    'ล้างกะหล่ำปลีและตัดเป็นเส้น ต้มน้ำเกลือ เพิ่มเส้นกะหล่ำปลีใบย่นและปรุงอาหารจนกว่าจะนุ่ม',
    'ใส่ครีมและนมลงในหม้ออีกใบแล้วตั้งไฟ ปล่อยให้มันต้มจนครึ่งหนึ่งของมันระเหย เพิ่มกะหล่ำปลีใบย่นและปรุงรสด้วยแกง ลูกจันทน์เทศ เกลือ และพริกไทย',
    'อุ่นน้ำมันมะกอกในกระทะ ทอดเนื้อแซลมอนที่ความร้อนปานกลางเป็นเวลา 3 นาที ปรุงรสด้วยเกลือและพริกไทย',
    'จัดเรียงทุกอย่างบนจานและปกคลุมแซลมอนด้วยชิ้นมะนาว โรยผักชีลาวทับ'
  ],
  portions: 2,
  tags: [ 'Nährstoffreich', 'Lunch' ]
} ,
{
  name: 'ผักอบหลากสี',
  prev: 'buntes_ofengemuese.jpg',
  time: '35 min.',
  ingredients: [
    'หนึ่งซูกินี',
    'พริกแดง 1',
    'หนึ่งพริกเหลือง',
    'เห็ด 300 กรัม',
    'มะเขือเทศ 4 ลูก',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'เปิดเตาอบที่อุณหภูมิ 200 องศาเซลเซียส',
    'ล้างและหั่นผักหั่นมะเขือเทศเป็นแปดชิ้น',
    'จัดถาดสำหรับอบด้วยกระดาษรองอบและแปรงด้วยน้ำมัน ใส่ผักบนถาดอบ ปรุงรสด้วยเกลือ พริกไทย และสมุนไพร',
    'นำเข้าอบประมาณ 20 นาที'
  ],
  portions: 2,
  tags: [ 'Leicht', 'Lunch', 'Vegan' ]
} ,
{
  name: 'แกงสตูว์ถั่ว',
  prev: 'burry_bohnen_eintopf.jpg',
  time: '35 min.',
  ingredients: [
    'หนึ่งซูกินี',
    'หัวหอม 1 ลูก',
    'หนึ่งพริกไทย',
    'น้ำเปล่า 500 มล.',
    'ถั่วขาว 1 กระป๋อง',
    'ซุปผัก 12 แครอท½ กระเทียมต้น1 ผักชีฝรั่ง',
    undefined,
    undefined
  ],
  preparation: [
    'ล้างผักสับพวกเขา ความร้อนน้ำมันมะกอกในหม้อ เพิ่มผักและทอด ปรุงรสด้วยเกลือ พริกไทย และแกง เติมน้ำและเคี่ยวประมาณ 20 นาที',
    'ล้างถั่วด้วยน้ำแล้วใส่ลงในหม้อ ปล่อยให้เคี่ยวเป็นเวลา 10 นาที’',
    'เสริ์ฟและจัดเรียงคุณสามารถหั่นไส้กรอกไก่งวงไขมันต่ำได้หากต้องการ”'
  ],
  portions: 2,
  tags: [ 'Deftig', 'Lunch' ]
} ,
{
  name: 'กุ้งทอด',
  prev: 'garnelenpfanne.jpg',
  time: '20 min.',
  ingredients: [
    'กุ้ง 400 กรัม (สดหรือแช่แข็ง)',
    'มะเขือเทศเชอรี่ 250 กรัม',
    'เห็ด 250 กรัม',
    '1 เลมอน',
    'มัสตาร์ด 1 ช้อนชา',
    'ต้นหอมสด 4 ต้น',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ละลายกุ้งแช่แข็งก่อนเตรียม',
    'อุ่นน้ำมันในกระทะ ผัดกุ้งในเวลาสั้น ๆ แล้วดีเกลซด้วยน้ำมะนาว',
    'ล้างเห็ด มะเขือเทศ และต้นหอมสด หั่นครึ่งเห็ดและมะเขือเทศ หั่นต้นหอมเป็นวง ใส่เห็ดในกระทะแล้วทอด',
    'ใส่มะเขือเทศเชอรี่และต้นหอมลงในกระทะ ทอดสักพัก',
    'ปรุงรสด้วยเกลือพริกไทยและมัสตาร์ด จัดเรียงและโรยด้วยพาร์สลีย์'
  ],
  portions: 2,
  tags: [ 'Leicht', 'Lunch' ]
} ,
{
  name: 'สมุนไพรแซลมอนกับถั่ว',
  prev: 'krrauter_lachs_mit_bohnen.jpg',
  time: '30 min.',
  ingredients: [
    'สเต็กปลาแซลมอนไร้หนัง 2 ชิ้น',
    'มะกอก 40 กรัม',
    'ถั่วลันเตา 200 กรัม',
    'ครีมชีสไขมันต่ำ 1 ช้อนโต๊ะ',
    'เนยสมุนไพร 2 ช้อนชา',
    'มะเขือเทศ 4 ลูก',
    undefined
  ],
  preparation: [
    'ปรุงรสสเต็กปลาแซลมอนด้วยเกลือและพริกไทย ล้างมะกอกและหั่นเป็นวง ๆ ผสมมะกอกกับเนยสมุนไพรและครีมชีส ปรุงรสด้วยเกลือและพริกไทย',
    'ล้างถั่วและต้มด้วยความร้อนปานกลางในน้ำเกลือ',
    'ล้างมะเขือเทศแล้วหั่นครึ่ง นำไปรวมกับสเต็กปลาแซลมอนในกระทะย่าง ทอดปลาทั้งสองด้านประมาณ 3 ถึง 4 นาที',
    'จัดเรียงสเต็กปอลาแซลมอนบนจานละลายเนยสมุนไพรและครีมชีสบนปลา เพิ่มถั่วแล้วเสริ์ฟ'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Lunch' ]
} ,
{
  name: 'พิซซ่าฟาลาเฟล',
  prev: 'falafelpizza.jpg',
  time: '30 min.',
  ingredients: [
    'ไข่หนึ่งลูก',
    'หัวหอม 1 ลูก',
    'ฟาลาเฟลผสม 1 ห่อ',
    'มะเขือเทศ 3 ลูก',
    'แฮม 2 สไลซ์',
    'หนึ่งพริกไทย',
    'เห็ด 100 กรัม'
  ],
  preparation: [
    'ปอกเปลือกและสับหัวหอมให้ละเอียด ล้างมะเขือเทศและเห็ดแล้วหั่นเป็นชิ้นเล็ก ๆ ล้างพริกเอาเมล็ดออกแล้วหั่นเป็นเส้นเล็ก ๆ หั่นแฮมเป็นชิ้นเล็ก ๆ',
    'เปิดเตาอบที่อุณหภูมิ 200 องศาเซลเซียส',
    'เตรียมส่วนผสมฟาลาเฟลตามคำแนะนำของแพ็คเกจ ปล่อยให้เปียกสักพัก',
    'ผสมส่วนผสมฟาลาเฟลที่เตรียมไว้กับก้อนหัวหอมและไข่ จากนั้นกระจายบนถาดอบที่มีกระดาษรองอบและอบประมาณ 5 นาที',
    'นำฐานพิซซ่าฟาลาเฟลออกจากเตาอบแล้วคลุมด้วยแฮมและผัก โรยพาเมซานชีสหากจำเป็น ใส่กลับเข้าไปในเตาอบแล้วอบต่ออีก 10 นาที'
  ],
  portions: 2,
  tags: [ 'Gesunde Alternative', 'Lunch', 'Snacks' ]
} ,
{
  name: 'ไก่งวงห่อ',
  prev: 'putengeschnetzeltes_mit_tomaten.jpg',
  time: '30 min.',
  ingredients: [
    'ไข่ 4 ฟอง',
    'อัลมอนด์บด 2 ช้อนโต๊ะ',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'ไก่งวงเจอร์กี 200 กรัม',
    'มะเขือเทศ 4 ลูก',
    'หนึ่งพริกไทย',
    'มัสตาร์ด 2 ช้อนชา',
    undefined
  ],
  preparation: [
    'อุ่นน้ำมันมะกอกนกระทะ',
    'ผสมไข่กับอัลมอนด์บดเข้าด้วยกัน ปรุงรสด้วยเกลือและพริกไทย',
    'เทของเหลวครึ่งหนึ่งลงในกระทะ กระจายให้ทั่วโดยคนในกระทะ ปล่อยให้เดือดในความร้อนปานกลาง ทำซ้ำสำหรับการห่อที่สอง',
    'ล้างมะเขือเทศและหั่นเป็นชิ้นเล็ก ๆ ล้างและเอาเมล็ดออกจากพริกแล้วหั่นเป็นชิ้นเล็ก ๆ',
    'อุ่นน้ำมันมะกอกในอีกกระทะ ใส่แถบไก่งวงและทอดสักพัก ปรุงรสด้วยเกลือและพริกไทย',
    'เคลือบทั้งสองชั้นด้วยมัสตาร์ด วางไก่งวงและผักทับ ม้วนแล้วเสิร์ฟ'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Lunch', 'Snacks' ]
} ,
{
  name: 'แกงกะทิสตูว์เลนทิล',
  prev: 'kokos_linsen.jpg',
  time: '20 min.',
  ingredients: [
    'เลนทิล 1 กระป๋องใหญ่',
    'ต้นหอมสด ½ พวง',
    'ผงกะหรี่ 2 ช้อนโต๊ะ',
    'พริกคาเยนหนึ่งช้อนชา',
    'ยี่หร่าหนึ่งช้อนชา',
    'กะทิ ½ กระป๋อง',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'อุ่นน้ำมันมะกอกในกระทะทอด',
    'ล้างต้นหอมสดแล้วหั่นเป็นวง ใส่ลงในกระทะแล้วผัดสักพัก จากนั้นใส่กะทิและเลนทิล ปรุงรสด้วยเครื่องเทศ เคี่ยวเป็นเวลา 15-20 นาที'
  ],
  portions: 1,
  tags: [ 'Exotisch', 'Lunch', 'Vegan' ]
} ,
{
  name: 'แซลมอนผัก',
  prev: 'lachsfilet_auf_gemuese.jpg',
  time: '30 min.',
  ingredients: [
    'หนึ่งซูกินี',
    'แซลมอนไร้หนัง 150 กรัม',
    'แคอรท 1 อัน',
    'บร็อคโคลี่ 1 อัน',
    'หัวหอม 1 ลูก',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างผักและหั่นเป็นชิ้นเล็ก ๆ ปอกเปลือกแครอทและหัวหอมแล้วหั่นเป็นชิ้นเล็ก ๆ อุ่นน้ำมันมะกอกในกระทะ',
    'วางปลาแซลมอนลงในกระทะแล้วทอดทั้งสองข้างที่ไฟร้อนปานกลาง หลังจาก 3 นาที ใส่ผักในกระทะ ดีเกลซด้วยน้ำเป็นครั้งคราว',
    'ปรุงรสด้วยเกลือและพริกไทย'
  ],
  portions: 2,
  tags: [ 'Nährstoffreich', 'Lunch' ]
} ,
{
  name: 'ไก่งวงกะทิ',
  prev: 'puten_kokos_pfanne.jpg',
  time: '20 min.',
  ingredients: [
    'เจอร์กี้ไก่งวง 400 กรัม',
    'เห็ด 1 กระป๋อง',
    'ต้นหอม 1 ต้น',
    'ถั่วเขียวหนึ่งกระป๋องเล็ก',
    'น้ำซุปข้นมะเขือเทศ 250 มล.',
    'กะทิ 20 มล.',
    'มะเขือเทศเพสโต้ 2 ช้อนโต๊ะ',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างต้นหอมและตัดเป็นวงแหวน ระบายเห็ดและถั่ว ตั้งน้ำมันมะกอกในกระทะ',
    'ทอดไก่งวงและหัวหอมที่ร้อนปานกลาง เพิ่มมะเขือเทศบด กะทิ และเพสโต้',
    'ใส่เห็ดและถั่ว ปรุงรสด้วยเกลือและพริกไทย เคี่ยวเป็นเวลา 10 นาทีที่ความร้อนปานกลาง'
  ],
  portions: 2,
  tags: [ 'Superschnell', 'Lunch' ]
} ,
{
  name: 'ไก่งวงสติฟกับซอสถั่ว',
  prev: 'putengeschnetzeltes_mit_curry_kokosmilch.jpg',
  time: '30 min.',
  ingredients: [
    '400 ซี่โครงไก่งวง',
    'กะทิ 200 มล.',
    'น้ำสต๊อกผัก 250 มล.',
    'นยถั่ว 4 ช้อนโต๊ะ (ไม่หวาน)',
    'แครอท 2 อัน',
    'กระเทียมสับละเอียด 1 หน่วย',
    'พริกขี้หนู 1 เม็ด',
    '1 ต้นหอม',
    'บรอกโคลี 200 กรัม',
    'มะนาว ½ ลูก',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างและหั่นบรอกโคลีและต้นหอม ล้าง ปอกเปลือก และหั่นแครอท บีบน้ำมะนาว อุ่นน้ำมันมะกอกในกระทะ',
    'ใส่ผักและไก่งวงลงในกระทะแล้วผัดสักพัก เติมน้ำ 150 มล. ลงในกระทะ เคี่ยวประมาณสองสามนาทีจนน้ำระเหย.',
    'ล้างพริกขี้หนู หั่นเป็นวง ๆ ปอกเปลือกกระเทียมและหั่นเป็นชิ้นเล็ก ๆ อุ่นน้ำมันมะกอกในหม้อ ผัดพริกและกระเทียมในกระทะสักพัก จากนั้นใส่กะทิและปล่อยให้เดือด',
    'นำหม้อออกจากเตา เพิ่มเนยถั่วและน้ำมะนาว ปรุงรสด้วยเกลือและพริกไทย.',
    'เสิร์ฟผักและเส้นไก่งวงสติฟกับซอสถั่ว'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch' ]
} ,
{
  name: 'เนื้อวัวสันในบนผักปาปริก้า',
  prev: 'rinderfilet_auf_paprikagemuse.jpg',
  time: '30 min.',
  ingredients: [
    'เนื้อวัวสันใน 2 ชิ้น',
    'พริก 3 เม็ด (แดงเหลือง)',
    'หัวหอม 1 ลูก',
    'เห็ด 150 กรัม',
    'กระเทียมสับละเอียด 1 หน่วย',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'อุ่นน้ำมันมะกอกในกระทะ ปอกเปลือกและสับกระเทียมให้ละเอียด ล้างพริก เอาเมล็ดออก และหั่นเป็นเส้น ปอกเปลือกและสับหัวหอมอย่างละเอียด ล้างและหั่นเห็ด',
    'ปรุงเนื้อวัวสันในด้วยเกลือและพริกไทย ผัดกระเทียมในกระทะสักพัก จากนั้นเพิ่มเนื้อวัวแล้วทอดประมาณ 7 นาทีในแต่ละด้าน นำออกจากกระทะแล้วปล่อยให้อุ่น',
    'ใส่พริก เห็ด และหัวหอมลงในกระทะที่ร้อน แล้วทอดประมาณ 5 นาที ปรุงรสด้วยเกลือและพริกไทย',
    'จัดเรียงผักย่างกับเนื้อวัวสันใน'
  ],
  portions: 2,
  tags: [ 'Für Feinschmecker', 'Lunch' ]
} ,
{
  name: 'โคลราบิทอด',
  prev: 'bratkohlrabi.jpg',
  time: '30 min.',
  ingredients: [
    'หัวหอม 1 ลูก',
    '1 โคลราบิ',
    'แฮมต้ม 2 สไลซ์',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ปอกเปลือกและหั่นโคลราบิเป็นชิ้นบาง ๆ ปอกหัวหอมและหั่นเป็นชิ้นเล็ก ๆ',
    'อุ่นน้ำมันมะกอกในกระทะ ใส่โคลราบิลงในกระทะแล้วทอดให้ร้อนปานกลางจนกระทั่งนิ่ม ในระหว่างนี้ให้ตัดแฮมเป็นเส้น',
    'เพิ่มหัวหอมและเส้นแฮมกับชิ้นโคลราบิ แล้วปรุงรสด้วยเกลือและพริกไทย'
  ],
  portions: 2,
  tags: [ 'Low Carb', 'Lunch', 'Snacks' ]
} ,
{
  name: 'สลัดชิคพีสไปซี่',
  prev: 'scharfer_kichererbsensalat.jpg',
  time: '10 min.',
  ingredients: [
    'ถั่วชิคพีสุก 300 กรัม',
    'หัวหอม 1 ลูก',
    'มะเขือเทศ 4 ลูก',
    '1 พริก (แดง/เหลือง)',
    'กระเทียมสับละเอียด 1 หน่วย',
    'ซอสมะเขือเทศเข้มข้น 1 ช้อนโต๊ะ',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'ซอสถั่วเหลือง 1 ช้อนโต๊ะ',
    'สมุนไพร 1 ช้อนโต๊ะ (เช่น พาร์สลีย์)',
    undefined
  ],
  preparation: [
    'ปอกเปลือกและสับกระเทียมและหัวหอมอย่างละเอียด จากนั้นคลุกเคล้ากับมะเขือเทศ น้ำมันมะกอก และซีอิ๊วขาว ปรุงรสด้วยผงปาปริก้า',
    'ล้างและสับพริกไทยและมะเขือเทศ ผสมกับถั่วชิคพีแล้วเทน้ำสลัดราด จากนั้นผสมสมุนไพรในตอนท้าย ปรุงรสด้วยเกลือและพริกไทย'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'บาเกตแซลมอนแตงกวา',
  prev: 'gurken_lachs.jpg',
  time: '10 min.',
  ingredients: [
    'แตงกวาใหญ่หนึ่งอัน',
    'แซลมอน 250 กรัม',
    'ชีสคอตเทจแปดช้อนโต๊ะ',
    'พาร์สลีย์ 2 ช้อนโต๊ะ (สดหรือแห้ง)',
    'กระเทียมสับละเอียด 1 หน่วย',
    'มะนาว ½ ลูก',
    'ถั่วกระป๋อง 2 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ปอกกระเทียม สับให้ละเอียด',
    'ล้างแตงกวา ปอกเปลือกแล้วหั่นครึ่ง เอาข้างในของแตงกวาออกอย่างระมัดระวังด้วยมีดแล้วสับเป็นชิ้นเล็ก ๆ',
    'บีบมะนาว ผสมน้ำมะนาวเข้ากับชีสคอตเทจ กระเทียม ถั่ว พาร์สลีย์ และชิ้นส่วนแตงกวา',
    'กระจายครีมลงบนครึ่งหนึ่งของแตงกวาแล้ววางแซลมอนรมควันทับ'
  ],
  portions: 2,
  tags: [ 'Leicht', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'ชีสคอตเทจทูน่า',
  prev: 'thunfisch_huettenkaese.png',
  time: '5 min.',
  ingredients: [
    'ชีสคอตเทจ 250 กรัม',
    'ทูน่า 1 กระป๋อง (ไม่มีน้ำมัน)',
    'ชีสนมเปรี้ยว 150 กรัม',
    '1 ต้นหอม',
    undefined
  ],
  preparation: [
    'ล้างต้นหอมแล้วหั่นเป็นวงแหวน เอาน้ำออกจากทูน่า',
    'ผสมทูน่า นมเปรี้ยว และต้นหอมเข้าด้วยกันในชาม',
    'ปรุงรสด้วยเกลือและพริกไทย'
  ],
  portions: 1,
  tags: [ 'Superschnell', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'แท่งผักจิ้ม',
  prev: 'gemuesesticks.png',
  time: '10 min.',
  ingredients: [
    'หนึ่งพริกไทย',
    'แตงกวา ½ ชิ้น',
    'แครอทสองอัน',
    'หัวไชเท้า ½ พวง',
    'ซูกินี ½ ชิ้น',
    'ชีสนมเปรี้ยวไขมันต่ำ 250 กรัม',
    'ต้นหอมจีน ½ พวง',
    'พริกขี้หนู ½ อัน (หรือพริกป่น)',
    undefined
  ],
  preparation: [
    'ล้างและปอกเปลือกผัก แล้วหั่นเป็นเส้นเล็ก ๆ',
    'ล้างต้นหอมจีนและพริกขี้หนู หั่นเป็นวงเล็กๆ',
    'ผสมชีสนมเปรี้ยวไขมันต่ำเข้ากับต้นหอมจีนและพริกขี้หนู ปรุงรสด้วยเกลือและพริกไทย ผัดในน้ำมะนาวหากต้องการ เสริ์ฟน้ำจิ้มในชามเล็กพร้อมกับแท่งผัก'
  ],
  portions: 1,
  tags: [ 'Leicht', 'Dinner', 'Snacks' ]
} ,
{
  name: 'ขรมอะโวคาโดเห็ด',
  prev: 'champignon_avocado_snack.jpg',
  time: '25 min.',
  ingredients: [
    'อะโวคาโดหนึ่งลูก',
    'เห็ด 100 กรัม',
    '½ ผักกาดแก้ว',
    'แคอรท 1 อัน',
    'มะเขือเทศหนึ่งลูก',
    'เม็ดมะม่วงหิมพานต์หนึ่งกำมือ',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    'นมเปรี้ยวไขมันต่ำสี่ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างและหั่นผักกาด จากนั้นใส่ในชาม ล้างแครอทและมะเขือเทศแล้วหั่นเป็นชิ้นเล็ก ๆ ใส่ลงในชาม',
    'หั่นครึ่งอะโวคาโด เอาตรงกลางและเนื้อเนื้ออะโวคาโดออกด้วยช้อน จากนั้นบดเนื้ออะโวคาโดหนึ่งลูกกับอีกครึ่งหนึ่งด้วยส้อม แล้วตัดอีกครึ่งหนึ่งเป็นชิ้นเล็ก ๆ',
    'อุ่นน้ำมันมะกอกในกระทะ ล้างและหั่นเห็ด ใส่ลงในกระทะแล้วทอดสักพัก เทเห็ดลงบนสลัด',
    'ผสมอะโวคาโดบดเข้ากับชีสนมเปรี้ยวไขมันต่ำ สับเม็ดมะม่วงหิมพานต์ให้ละเอียดแล้วใส่ในควาร์กอะโวคาโด ปรุงรสด้วยเกลือและพริกไทย เทลงบนสลัด'
  ],
  portions: 1,
  tags: [ 'Gut vorzubereiten', 'Dinner', 'Snacks' ]
} ,
{
  name: 'สลัดหลากสีกับซอสค็อกเทลกะทิ',
  prev: 'salat_mit_kokos_coacktailsauce.jpg',
  time: '10 min.',
  ingredients: [
    '½ ผักกาดแก้ว',
    'มะเขือเทศ 2 ลูก',
    'แฮม 30 กรัม',
    'แตงกวา ½ ชิ้น',
    'ไข่ต้มสองลูก',
    'กะทิ 200 มล.',
    'ซอสมะเขือเทศเข้มข้น 1 ช้อนโต๊ะ',
    'มัสตาร์ด ½ ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างและปอกเปลือกผักแล้วหั่นเป็นชิ้นเล็ก ๆ ปอกเปลือกและสับไข่ ตัดแฮมเป็นเส้น ใส่ส่วนผสมทั้งหมดลงในชาม',
    'ผสมซอสมะเขือเทศเข้มข้น กะทิ และมัสตาร์ดเข้าด้วยกัน จากนั้นปรุงรส',
    'ราดน้ำสลัด'
  ],
  portions: 1,
  tags: [ 'Exotisch', 'Dinner', 'Snacks' ]
} ,
{
  name: 'สลัดถั่วทูน่า',
  prev: 'thunfisch_bohnen.jpg',
  time: '10 min.',
  ingredients: [
    'ทูน่าในน้ำเกลือ ½ กระป๋อง',
    'มะเขือเทศเชอรี่สามลูก',
    'ถั่วแดงหลวง 80 กรัม',
    'หัวหอม 1 ลูก',
    'ข้าวโพด 50 กรัม',
    undefined,
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างและหั่นมะเขือเทศ ปอกเปลือกและสับหัวหอมให้ละเอียด ทำให้ถั่วและข้าวโพดแห้ง ล้างและหั่นพาร์สลีย์',
    'ใส่ผักในชาม เทน้ำมันมะกอกราด ปรุงรสด้วยเกลือและพริกไทย'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Dinner', 'Snacks' ]
} ,
{
  name: 'สลัดโปรตีน',
  prev: 'protein_power.jpg',
  time: '25 min.',
  ingredients: [
    'ไข่สองลูก',
    'อกไข่หนึ่งชิ้น',
    'ต้นหอม 1 ต้น',
    'เมล็ดทานตะวัน 1 ช้อนโต๊ะ',
    'มะเขือเทศหนึ่งลูก',
    'แตงกวา ½ ชิ้น',
    'โยเกิร์ตธรรมชาติ 1 ช้อนโต๊ะ',
    'น้ำส้ม 1 ช้อนโต๊ะ',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    undefined,
    undefined
  ],
  preparation: [
    'ล้างและสับมะเขือเทศ ต้นหอม และแตงกวา ตัดอกไก่เป็นเส้น ต้มน้ำในหม้อแล้วต้มไข่เป็นเวลา 10 นาที ปอกเปลือกและสับไข่ ใส่ส่วนผสมทั้งหมดลงในชาม',
    'ความร้อนน้ำมันมะกอกในกระทะ ผัดไก่สักพัก ปรุงรสด้วยเกลือและพริกไทย. ใส่ไก่เส้นในชาม',
    'ผสมโยเกิร์ต น้ำส้มสายชู น้ำมันมะกอก 1 ช้อนโต๊ะ และมัสตาร์ดเข้าด้วยกัน ปรุงรสด้วยเกลือและพริกไทยแล้วใส่สลัด โรยหน้าสลัดด้วยเมล็ดทานตะวันตามต้องการ'
  ],
  portions: 1,
  tags: [ 'Mit Hähnchenfilet', 'Dinner', 'Snacks' ]
} ,
{
  name: 'สลัดสเต็กอะโวคาโด',
  prev: 'avocado_steak.jpg',
  time: '30 min.',
  ingredients: [
    'สเต็กเนื้อหนึ่งชิ้น',
    'น้ำมันมะกอก 2 ช้อนโต๊ะ',
    'มะเขือเทศ 4 ลูก',
    'หัวหอม ½ ลูก',
    undefined,
    'แตงกวา ½ ชิ้น',
    'อะโวคาโด ½ ลูก',
    'น้ำผึ้งหนึ่งช้อนชา',
    'น้ำมะนาว 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'อุ่นน้ำมันมะกอกในกระทะ ปรุงสเต็กด้วยเกลือและพริกไทย จากนั้นทอดที่ความร้อนปานกลางเป็นเวลา 4-6 นาทีของแต่ละด้าน',
    'ผสมน้ำมะนาว น้ำผึ้ง และน้ำมันมะกอก 1 ช้อนโต๊ะในชามขนาดเล็ก ปรุงรสด้วยผงพริกและพริกไทย',
    'ล้างผัก หั่นสลัดเป็นชิ้นพอดีคำ ปอกเปลือกและเอาเมล็ดออกจากอะโวคาโดแล้วหั่นเป็นชิ้นเล็ก ๆ หั่นครึ่งมะเขือเทศเชอรี่ หั่นหัวหอมและแตงกวาให้ละเอียด หั่นสเต็กเป็นชิ้นขนาดพอดีคำ ใส่ส่วนผสมทั้งหมดลงในชามแล้วราดน้ำสลัด'
  ],
  portions: 1,
  tags: [ 'Für Feinschmecker', 'Lunch', 'Dinner', 'Snacks' ]
} ,
{
  name: 'สลักเต้าหู้และไข่กับควินัว',
  prev: 'tofu_ei_salat_mit_quinoa.jpg',
  time: '15 min.',
  ingredients: [
    'เต้าหู้ 100 กรัม',
    'ควินัว (ดิบ) 50 กรัม',
    'ไข่หนึ่งลูก',
    'ต้นหอม 2 ต้น',
    'มะเขือเทศหนึ่งลูก',
    '½ ปาปริก้า',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'น้ำเลมอน 2 ช้อนชา',
    'พาร์สลีย์หนึ่งต้น',
    undefined
  ],
  preparation: [
    'แช่ควินัวในน้ำเกลือเป็นเวลา 10 นาที ต้มไข่เป็นเวลา 10 นาที',
    'หั่นเต้าหู้ให้เป็นลูกเต๋า ล้างมะเขือเทศและพริก หั่นเป็นชิ้นเล็ก ๆ ล้างต้นหอม หั่นเป็นวง ล้างพาร์สลีย์ จากนั้นหั่นให้ละเอียด',
    'ผสมน้ำมันมะกอกกับน้ำมะนาว ปรุงรสด้วยพริกไทย สับไข่ต้ม',
    'ผสมควินัวกับผักและชาม ราดน้ำสลัดแล้วเสิร์ฟ'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Dinner', 'Snacks' ]
} ,
{
  name: 'ไข่ดาวกับถั่วเขียวและเบคอน',
  prev: 'spiegelei_bohnen.jpg',
  time: '15 min.',
  ingredients: [
    'ไข่ 1-2 ฟอง',
    'ถั่วลันเตา 200 กรัม',
    'เบคอนหรือแฮม 50 กรัม',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างถั่วเขียวแล้วหั่นปลายออก ต้มน้ำใส่เกลือในหม้อ เอาถั่วไปต้มที่ความร้อนปานกลางเป็นเวลา 10 นาที ตัดเบคอนเป็นชิ้นเล็กๆ',
    'อุ่นน้ำมันมะกอกบนกระทะ ทอดชิ้นเบคอนเป็นเวลาซักครู่แล้วเอาขึ้น จากนั้นตอกไข่ลงในกระทะ ปรุงรสด้วยเกลือและพริกไทย',
    'จัดแต่งถั่วเขียวเบคอน และไข่ดาวลงบนจาน ปรุงรสด้วยเกลือและพริกไทยตามต้องการ'
  ],
  portions: 1,
  tags: [ 'Deftig', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'แครอทซักชินีบัฟเฟอร์',
  prev: 'karotten_zucchini_puffer.jpg',
  time: '20 min.',
  ingredients: [
    'แครอท 150 กรัม',
    'ซูกินี ½ ชิ้น',
    'น้ำมะนาวครึ่งช้อนโต๊ะ',
    'ผักชี 1 ช้อนโต๊ะ',
    'ไข่หนึ่งลูก',
    'ข้าวโอ๊ต 4 ช้อนโต๊ะ',
    'ชีสนมเปรี้ยวสมุนไพรไขมันต่ำ 2 ช้อนโต๊ะ',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างและปลอกเปลือกแครอทและซักชินีและนำไปขูดโดยตะแกรงขูดผัก',
    'ผสมผักที่ขูดได้เข้ากับน้ำมะนาวผักชีฝรั่งสับไข่และข้าวโอ๊ต ปรุงรสด้วยเกลือและน้ำตาล',
    'อุ่นน้ำมันมะกอกบนกระทะ ใช้ช้อนตักเป็นคำลงบนกระทะร้อน กดให้ชิ้นบัฟเฟอร์บางลงเล็กน้อย ทอดทั้งสองด้านด้วยความร้อนปานกลาง',
    'จัดแพนเค้กผักเข้ากับนมเปรี้ยวสมุนไพรบนจาน'
  ],
  portions: 1,
  tags: [ 'Low Carb', 'Lunch', 'Dinner', 'Snacks' ]
} ,
{
  name: 'สลัดถั่วโหระพา',
  prev: 'basilikum_bohnen.jpg',
  time: '15 min.',
  ingredients: [
    'ถั่วลันเตา 200 กรัม',
    'ถั่วไพน์ 1 ช้อนชา',
    undefined,
    'กานพลู ½  ',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างถั่วเขียว ตัดปลายสองข้างแล้วนำไปต้ม 10 นาที',
    'ล้างโหระพา เด็ดใบแล้วนำมาสับละเอียด ปอกเปลือกแล้วทุบกระเทียม',
    'ผสมกระเทียม ใบโหระพา และน้ำมันมะกอก เทราดบนถั่วต้มสุกแล้วโรยตกแต่งด้วยถั่วไพน์'
  ],
  portions: 1,
  tags: [ 'Gut vorzubereiten', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'ไข่ทอดผักปวยเล้ง',
  prev: 'spinat_spiegelei.jpg',
  time: '15 min.',
  ingredients: [
    'ไข่ 3 ฟอง',
    'โยเกิร์ตไขมันต่ำ 3 ช้อนโต๊ะ',
    'ผักปวยเล้ง(สดหรือแช่ก็ได้) 150 กรัม',
    'น้ำมันมะกอก 1 ช้อนชา',
    undefined
  ],
  preparation: [
    'อุ่นน้ำมันมะกอกบนกระทะ ใส่ผักปวยเล้งลงไป ทอดสักครู่แล้วดันไปขอบกระทะ',
    'ตอกไข่ลงกระทะทีละใบ ปรุงด้วยพริกไทยและเกลือ',
    'ผสมพริกผงกับโยเกิร์ต จากนั้นปรุงรสด้วยเกลือ พริกไทยและผงปาปริกา เสิร์ฟไข่ดาวคู่กับผักปวยเล้ง'
  ],
  portions: 1,
  tags: [ 'Voller Mineralstoffe', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'ซีเรียลเบอร์รี่',
  prev: 'beerenmuesli.png',
  time: '10 min.',
  ingredients: [
    'ข้าวโอ๊ต 50 กรัม',
    'อัลมอนด์ 3 ออนซ์',
    'เบอร์รี่(สดหรือแช่ก็ได้)',
    'ชีสนมเปรี้ยวไขมันต่ำ 250 กรัม',
    'นมสดไขมันต่ำ 150 มก.'
  ],
  preparation: [
    'นำอัลมอนด์ไปคั่วซักพักในกระทะเป็นเวลา 4 นาทีด้วยไฟปานกลางจากนั้นนำไปสับละเอียด ล้างลูกเบอร์รี่',
    'ผสมเกล็ดข้าวโอ๊ตสับอัลมอนด์ใส่เบอร์รี่(สดหรือแช่ก็ได้)นม และนมเปรี้ยวไขมันต่ำ'
  ],
  portions: 1,
  tags: [ 'Nährstoffreich', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'ไข่คนสูตรเมดิเตอร์เรเนียน',
  prev: 'mediteranes_ruehrei.png',
  time: '15 min.',
  ingredients: [
    'ไข่ 3 ฟอง',
    'มะเขือเทศ 4 ลูก',
    'ใบอะรูกูลา 20 กรัม',
    'เฟต้าชีส 100 กรัม',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างมะเขือเทศและใบอะรูกูลา ตัดมะเขือเทศเป็นรูปลูกบาศก์รวมทั้งสับใบอะรูกูลาให้ละเอียด จากนั้นตัดเฟต้าชีสเป็นลูกบาศก์เล็ก',
    'ใส่ไข่และใบอะรูกูลารวมกันในถ้วย ตีให้เข้ากันและปรุงด้วยพริกไทย',
    'อุ่นน้ำมันมะกอกบนกระทะ ใส่มะเขือเทศลงไปทอดเล็กน้อย แล้วนำไข่ลงไปในกระทะและปล่อยให้ฟูขึ้น ปรุงรสด้วยพริกไทย',
    'เสิร์ฟไข่ทอดบนจานคู่กับเกล็ดและชิ้นเฟต้าชีส'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'กราโนลาถั่วและแอปเปิ้ล',
  prev: 'nuss_apfel_muesli.jpg',
  time: '5 min.',
  ingredients: [
    'แอปเปิ้ล 1 ลูก',
    'วอลนัท 30 กรัม',
    'ข้าวโอ๊ต 50 กรัม',
    'นมเปรี้ยวไขมันต่ำ 200 กรัม',
    'นมสดไขมันต่ำ 150 มก.',
    undefined
  ],
  preparation: [
    'ล้างแอปเปิ้ลหั่นเป็นชิ้นเล็กๆบดถั่วละเอียด',
    'ผสมข้าวโอ๊ตชิ้นแอปเปิ้ลวอลนัท  พร้อมกับนมเปรี้ยวไขมันต่ำ และนมสดโรยหน้าซีเรียลนี้ด้วยอบเชย'
  ],
  portions: 1,
  tags: [ 'Sättigend', 'Breakfast', 'Snacks' ]
} ,
{
  name: 'เบคอนกับไข่',
  prev: 'bacon_eggs.png',
  time: '10 min.',
  ingredients: [
    'ไข่ 3 ฟอง',
    'เบคอนไขมันต่ำ 4 แผ่น',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'อุ่นน้ำมันบนกระทะ ทอดเบคอนสักครู่นึง แล้วนำขึ้นมา และอย่าให้มันเย็น',
    'ตอกไข่ลงบนกระทะแล้วทอด ปรุงรสด้วยเกลือและพริกไทย'
  ],
  portions: 1,
  tags: [ 'Deftig', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'มิ้นท์เชคซ่า',
  prev: 'minz_gurke.jpg',
  time: '5 min.',
  ingredients: [
    'ชีสนมเปรี้ยวไขมันต่ำ 250 กรัม',
    '“มิ้นท์สด 1 กำมือ”',
    'แตงกวา ½ ชิ้น',
    'มะนาว ½ ลูก',
    'น้ำเปล่า 200 มล.'
  ],
  preparation: [
    'ล้างแตงกวาและใบมิ้นท์ ตัดแตงกวาให้เป็นชิ้นเล็กๆ บีบมะนาว',
    'ใส่ส่วนผสมทั้งหมดลงในเครื่องปั่นแบบสูงแล้วปั่นละเอียดด้วยเครื่องปั่นผลไม้'
  ],
  portions: 1,
  tags: [ 'Erfrischend', 'Dinner', 'Drink' ]
} ,
{
  name: 'ลูกพีชเชคซ่า',
  prev: 'pfirsich_gurke.jpg',
  time: '10 min.',
  ingredients: [
    'ลูกพีช 2 ลูก',
    undefined,
    'น้ำเปล่า 50 มล.',
    'โยเกิร์ตรสจืด 200 กรัม',
    'น้ำผึ้งหนึ่งช้อนชา'
  ],
  preparation: [
    'ล้างลูกพีชและแตงกวา ตัดเป็นชิ้นเล็กๆ',
    'ใส่โยเกิร์ตธรรมชาติผสมกับน้ำ รวมถึงใส่ชิ้นลูกพีชและชิ้นแตงกวาลงไปรวมในเครื่องปั่นสูง ปั่นด้วยเครื่องปั่นมือ เติมความหวานด้วยน้ำผึ้ง',
    'เสิร์ฟขณะเย็น'
  ],
  portions: 1,
  tags: [ 'Einfach', 'Dinner', 'Drink' ]
} ,
{
  name: 'ชามะนาวเย็นใส่ขิง',
  prev: 'limetten_ingwer.jpg',
  time: '15 min.',
  ingredients: [
    'ถุงชา 4 ถุง',
    'มะนาว 2 ลูก',
    'ขิงสด 35 กรัม',
    'น้ำเปล่า 500 มล.',
    'น้ำผึ้ง 2 ช้อนชา',
    undefined
  ],
  preparation: [
    'ล้างปลอกเปลือก และหั่นขิง จากนั้นล้างมะนาวและฝานเป็นแผ่นบาง',
    'ต้มน้ำในกาต้มน้ำ แล้วเทใส่ในภาชนะขนาดใหญ่ เอาขิงกับมะนาวชิ้นลง จากนั้นแช่ไว้ 5 นาที',
    'ใส่ถุงชาลงไปและปล่อยทิ้งไว้ 5 นาที ครบแล้วนำถุงชาออก เพิ่มความหวานด้วยน้ำผึ้ง 2 ช้อนชาได้หากต้องการ ปล่อยให้ชาเย็นลง',
    'ใส่น้ำแข็งให้เป็นชาเย็น'
  ],
  portions: 4,
  tags: [ 'Aromatisch', 'Drink' ]
} ,
{
  name: 'ชามะนาวบลูเบอร์รี่เย็น',
  prev: 'zitronen_eistee.jpg',
  time: '15 min.',
  ingredients: [ 'ชาดำสี่ถุง', '1 ส้ม', '1 เลมอน', 'น้ำเปล่า 500 มล.', undefined ],
  preparation: [
    'ล้างมะนาวและบลูเบอร์รี่ ตัดมะนาวเป็นแผ่นบาง',
    'ต้มน้ำในกาน้ำร้อนแล้วเอาไปใส่ภาชนะขนาดใหญ่ ใส่ถุงชาลงไปแล้วรอให้มันละลายประมาณ 5 นาที แล้วจึงเอาถุงชาออกอีกครั้งหนึ่ง',
    'ใส่มะนาวแผ่นกับบลูเบอร์รี่ไปในชา เอาไปใส่ในตู้เย็น ทิ้งไว้ให้เย็นลง',
    'เสิร์ฟพร้อมก้อนไข่ในแก้ว'
  ],
  portions: 4,
  tags: [ 'Erfrischend', 'Drink' ]
} ,
{
  name: 'ชาเย็นมะนาวบลูเบอร์รี่',
  prev: 'zitronen_blaubeer.jpg',
  time: '15 min.',
  ingredients: [
    'ถุงชา 4 ถุง',
    'บลูเบอร์รี่ 200 กรัม',
    '1 เลมอน',
    'น้ำเปล่า 500 มล.',
    undefined
  ],
  preparation: [
    'ล้างมะนาวและบลูเบอร์รี่ ตัดมะนาวเป็นชิ้นบาง ๆ',
    'ต้มน้ำในกาต้มน้ำและใส่ในภาชนะขนาดใหญ่ เพิ่มถุงชาและปล่อยให้มันชงประมาณ 5 นาที จากนั้นนำถุงชาออกมาอีกครั้ง',
    'เพิ่มชิ้นมะนาวและบลูเบอร์รี่ลงในชา ทำให้ชาเย็นในตู้เย็นและปล่อยให้มันสูงชัน',
    'เสิร์ฟพร้อมก้อนไข่ในแก้ว'
  ],
  portions: 4,
  tags: [ 'Aromatisch', 'Drink' ]
} ,
{
  name: 'สมูทธตี้สัปปะรดส้ม',
  prev: 'ananas_orange.jpg',
  time: '5 min.',
  ingredients: [
    'สัปปะรด 150 กรัม (3-4แถว)',
    '1 ส้ม',
    'ผักปวยเล้ง 100 กรัม',
    'น้ำ 250 มล.'
  ],
  preparation: [
    'ล้างผักปวยเล้งและส้ม ปลอกเปลือกส้มแล้วหั่นเป็นชิ้นเล็กๆ หั่นสัปปะรดเป็นชิ้นเล็กๆ',
    'ใส่น้ำผลไม้และผักไปในภาชนะทรงสูง “ปั่นด้วยเครื่องปั่นมือ'
  ],
  portions: 1,
  tags: [ 'Exotisch', 'Drink', 'Vegan' ]
} ,
{
  name: 'สมูทธตี้เบอร์รี่เพิ่มพลัง',
  prev: 'beeren_power.jpg',
  time: '5 min.',
  ingredients: [
    'เบอร์รี่ 250 กรัม (เช่น สตรอวเบอร์รี่)',
    'มะม่วงครึ่งลูก',
    'น้ำเปล่า 250 มล.',
    'ผักปวยเล้ง 100 กรัม'
  ],
  preparation: [
    'ล้างเบอร์รี่ผักปวยเล้ง และมะม่วง ปลอกเปลือกมะม่วง จากนั้นตัดเป็นชิ้นเล็กๆ',
    'ใส่น้ำผลไม้และผักไปในภาชนะทรงสูง “ปั่นด้วยเครื่องปั่นมือ'
  ],
  portions: 1,
  tags: [ 'Vitaminbombe', 'Drink', 'Vegan' ]
} ,
{
  name: 'สมูทธตี้ลูกแพรกล้วย',
  prev: 'birnen_bananen.jpg',
  time: '5 min.',
  ingredients: [
    'ลูกแพร 2 ลูก',
    'กล้วย 1 ผล',
    'ผักปวยเล้ง 100 กรัม',
    'น้ำ 250 มล.'
  ],
  preparation: [
    'ล้างลูกแพรและผักปวยเล้ง ปลอกกล้วยแล้วตัดเป็นชิ้นเล็กๆ',
    'ใส่น้ำผลไม้และผักไปในภาชนะทรงสูง “ปั่นด้วยเครื่องปั่นมือ'
  ],
  portions: 1,
  tags: [ 'Fruchtig', 'Drink', 'Vegan' ]
} ,
{
  name: 'สมูทธตี้ผักชีแอปเปิ้ล',
  prev: 'petersilie_apfel.jpg',
  time: '5 min.',
  ingredients: [ 'แอปเปิ้ล 3 ผล', 'ผักชี 150 กรัม', 'ขิง 10 กรัม' ],
  preparation: [
    'ล้าง ปลอกเปลือก และหั่นขิง จากนั้นล้างแอปเปิ้ลและผักชี หั่นแอปเปิ้ลอย่างละเอียด',
    'ใส่วัตถุดิบทุกอย่างลงในภาชนะทรงสูง “ปั่นให้เข้ากันด้วยเครื่องปั่นมือ'
  ],
  portions: 1,
  tags: [ 'Originelle Idee', 'Drink', 'Vegan' ]
} ,
{
  name: 'กล้วยเชค',
  prev: 'bananen_shake.jpg',
  time: '10 min.',
  ingredients: [
    'กล้วย 1 ผล',
    'นมเปรี้ยวไขมันต่ำ 200 กรัม',
    'น้ำผึ้งหนึ่งช้อนชา',
    'น้ำเปล่า 400 มล.'
  ],
  preparation: [
    'ปลอกกล้วยแล้วหั่น',
    'ใส่น้ำผึ้งนมเปรี้ยวไขมันต่ำ และน้ำลงในภาชนะทรงสูงแล้วปั่นด้วยเครื่องปั่นมือ'
  ],
  portions: 1,
  tags: [ 'Der Klassiker', 'Snacks', 'Drink' ]
} ,
{
  name: 'เบอร์รี่น้ำผึ้งเชค',
  prev: 'honig_beeren.jpg',
  time: '5 min.',
  ingredients: [
    'ชีสนมเปรี้ยวไขมันต่ำ 250 กรัม',
    'เบอร์รี่แช่แข็ง 200 กรัม',
    'น้ำเปล่า 200 มล.',
    'น้ำผึ้งหนึ่งช้อนชา'
  ],
  preparation: [
    'ใส่วัตถุดิบทั้งหมดลงในขวดโหลทรงสูงแล้วเขย่าให้ผสมกันละเอียด',
    'ถ้าเบอร์รี่เป็นของสด ใส่น้ำแข็งบดลงไปเล็กน้อย'
  ],
  portions: 1,
  tags: [ 'Fruchtig', 'Snacks', 'Drink' ]
} ,
{
  name: 'แอปเปิ้ลกีวี่เชค',
  prev: 'apfel_kiwi_smoothie.jpg',
  time: '5 min.',
  ingredients: [
    'แอปเปิ้ล 1 ลูก',
    'กีวี่สุก 1 ผล',
    'โยเกิร์ตรสจืด 4 ช้อนโต๊ะ',
    'นมเปรี้ยวไขมันต่ำ 3 ช้อนโต๊ะ',
    'น้ำแข็ง 2-3 ก้อน',
    'น้ำเปล่า 250 มล.'
  ],
  preparation: [
    'ปอกแอปเปิ้ลและกีวี่ เอาเมล็ดแอปเปิ้ลออก ตัดผลไม้เป็นชิ้นเล็กๆ',
    'ใส่วัตถุดิบทุกอย่างลงในภาชนะทรงสูง “ปั่นให้เข้ากันด้วยเครื่องปั่นมือ'
  ],
  portions: 1,
  tags: [ 'Superschnell', 'Snacks', 'Drink' ]
} ,
{
  name: 'ลูกพีชและกล้วยเชค',
  prev: 'pfirsich_bananen.jpg',
  time: '10 min.',
  ingredients: [
    'ลูกพีชสุก 1 ผล',
    'กล้วยสุกหนึ่งลูก',
    'น้ำผึ้งหนึ่งช้อนชา',
    'นมเปรี้ยวไขมันต่ำ 5 ช้อนโต๊ะ',
    'น้ำเย็น 300 มล.'
  ],
  preparation: [
    'ล้างลูกพีช ปอกเปลือกกล้วยและลูกพีชออก “ตัดผลไม้เป็นชิ้นเล็กๆ',
    'นำวัตถุดิบทั้งหมดใส่ในภาชนะทรงสูงแล้วปั่นด้วยเครื่องปั่นมือ'
  ],
  portions: 1,
  tags: [ 'Vitaminbombe', 'Snacks', 'Drink' ]
} ,
{
  name: 'กีวี่มะนาวเชค',
  prev: 'kiwi_zitronen_shake.jpg',
  time: '10 min.',
  ingredients: [
    'กีวี่ 2 ผล',
    'สัปปะรด 3 ชิ้น',
    'มะนาว ½ ลูก',
    'น้ำผึ้งหนึ่งช้อนชา',
    'นมเปรี้ยวไขมันต่ำ 150 กรัม',
    'น้ำแข็งบด 2 ช้อนชา'
  ],
  preparation: [
    'ปอกเปลือกกีวี่แล้วตัดเป็นชิ้นเล็กๆ ตัดสัปปะรดเป็นชิ้นเล็กๆเช่นกัน แล้วบีบมะนาว',
    'เอาน้ำมะนาวมาผสมกับน้ำผึ้ง',
    'เอาวัตถุดิบเข้าเครื่องปั่นทรงสูงแล้วปั่น'
  ],
  portions: 1,
  tags: [ 'Vitaminbombe', 'Snacks', 'Drink' ]
} ,
{
  name: 'มะพร้าวช็อคโกแลตเชค',
  prev: 'schoko_kokos.jpg',
  time: '10 min.',
  ingredients: [
    'กะทิ 100 มล.',
    'ผงโกโก้ 1 ช้อนชา (แบบไม่มีน้ำตาล)',
    'นมไขมันต่ำ 100 มล.',
    'น้ำแข็งบด 1 ช้อนโต๊ะ',
    'เศษมะพร้าวขูด 1 ช้อนชา'
  ],
  preparation: [
    'ผสมผงโกโก้เข้ากับนมมะพร้าวนมสด และไอศกรีม ในภาชนะปิดสนิทได้ (เช่น ที่เขย่า) แล้วเขย่าอย่างแรง',
    'โรยหน้าด้วยเกล็ดมะพร้าว'
  ],
  portions: 1,
  tags: [ 'Fruchtig-süß', 'Snacks', 'Drink' ]
} ,
{
  name: 'เชคเพิ่มพลัง',
  prev: 'starter_shake.png',
  time: '5 min.',
  ingredients: [
    'ข้าวโอ๊ต 40 กรัม',
    'เมล็ดอมาแรนท์คั่ว 20 กรัม',
    'เบอร์รี่ 100 กรัม (เช่นบลูเบอร์รี่)',
    'นมข้าวโอ๊ต 400 มล.',
    'เมล็ดแฟลกซ์ 1 ช้อนโต๊ะ',
    'เมล็ดวอลนัท 3 ออนซ์',
    'น้ำหวานอะกาเว 1 ช้อนโต๊ะ',
    'น้ำแข็งก้อน 4 ก้อน',
    'ผงมัชชะ 1 ช้อนชา'
  ],
  preparation: [ 'เมล็ดวอลนัทบด', 'รวมวัตถุดิบทั้งหมดลงในเครื่องปั่นแล้วปั่น' ],
  portions: 1,
  tags: [ 'Superschnell', 'Breakfast', 'Snacks', 'Vegan' ]
} ,
{
  name: 'แพนเค้กกรอบกับครีมราสเบอร์รี่',
  prev: 'pancake.jpg',
  time: '20 min.',
  ingredients: [
    'แป้งธัญพืช 60 กรัม',
    'น้ำเชื่อมอะกาเว 10 กรัม',
    'นมถั่วเหลือง 140 กรัม',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'เบคกิ้งโซดา 1 ช้อนชา',
    'เมล็ดอมาแรนท์คั่ว 30 กรัม',
    'ราสเบอร์รี่ (แช่แข็ง) 150 กรัม',
    'น้ำเชื่อมอะกาเว 1 ออนซ์',
    'โยเกิร์ตถั่วเหลืองรสจืด 100 กรัม'
  ],
  preparation: [
    'ผสมแป้งธัญพืชน้ำเชื่อมอะกาเว 10 กรัมนมถั่วเหลืองผงฟูเข้าด้วยกัน และใช้เกลือเล็กน้อยโรยบนแป้ง จากนั้นใส่เมล็ดอมาแรนท์พับเข้าไปข้างใน',
    'อุ่นน้ำมันมะกอกบนกระทะแล้วตักแป้ง 1 ช้อนโต๊ะลงบนกระทะ จากนั้นทำเป็นแพนเค้ก 6 ชิ้น ทีละอัน ให้ทอดทั้งสองฝั่งที่ความร้อนปานกลางประมาณ 4 นาที',
    'ผสมราสเบอร์รี่น้ำเชื่อมอะกาเว 30 กรัม และโยเกิร์ตถั่วเหลืองในเครื่องผสมแล้วผสมให้ละเอียด',
    'นำครีมราสเบอร์รี่ไปเสิร์ฟคู่กับแพนเค้ก'
  ],
  portions: 2,
  tags: [ 'Ballaststoffreiche Alternative', 'Breakfast', 'Snacks', 'Vegan' ]
} ,
{
  name: 'กราโนล่าโกโก้แครนเบอร์รี่',
  prev: 'cranberry_kokos.jpg',
  time: '10 min.',
  ingredients: [
    'ข้าวโอ๊ต 100 กรัม',
    'นมมะพร้าว 50 กรัม',
    'น้ำเชื่อมอะกาเว 1 ออนซ์',
    'แครนเบอร์รี่ 40 กรัม',
    'โยเกิร์ตถั่วเหลือง 160 กรัม',
    'สัปปะรด 2 ชิ้น',
    'เกล็ดมะพร้าว 2 ออนซ์'
  ],
  preparation: [
    'ผสมเกล็ดข้าวโอ๊ตเข้ากับนมมะพร้าวน้ำเชื่อมอะกาเวแครนเบอร์รี่ และโยเกิร์ตถั่วเหลืองในถ้วย ปล่อยทิ้งไว้ 4 นาที',
    'ตัดชิ้นสัปปะรดให้เป็นชิ้นเล็กๆ',
    'ผสมชิ้นสัปปะรดกับเกล็ดมะพร้าวเข้ากับมูสลี่ย์ที่เหลือ'
  ],
  portions: 1,
  tags: [ 'Nährstoffreich', 'Breakfast', 'Snacks', 'Vegan' ]
} ,
{
  name: 'สลัดมันหวาน',
  prev: 'suesskartoffelsalat.jpg',
  time: '30 min.',
  ingredients: [
    'มันเทศขนาดใหญ่หนึ่งอัน',
    'ต้นอ่อนผสม 100 กรัม (เช่น ต้นอ่อนผักชี)',
    undefined,
    'น้ำส้มสายชูขาว 2 ช้อนโต๊ะ',
    undefined,
    'ฮอร์สราดิช 1 ช้อนชา',
    'น้ำมันมะกอก 3 ช้อนโต๊ะ',
    undefined,
    'ต้นหอม 2 ต้น',
    undefined,
    undefined
  ],
  preparation: [
    'ล้างมันหวานแล้วต้มในน้ำเกลือจนมันอ่อน สะเด็ดน้ำ ปอกเปลือกแล้วตัดเป็นชิ้นเล็กๆ',
    'ขณะเดียวกัน ล้างและบีบมะนาว เอาน้ำมะนาวมาผสมน้ำส้มสายชูมัสตาร์ดฮอร์สราดิชเกลือและพริกไทย สุดท้ายใส่น้ำมันมะกอกเข้าไป',
    'ล้างผักชี จากนั้นสะเด็ดให้แก้งแล้วเด็ดใบ ล้างต้นหอมแล้วตัดให้เป็นแว่นๆ',
    'เอามันหวานผักชีหัวหอม และต้นอ่อนมาใส่ถ้วย ปรุงรสด้วยเกลือและพริกไทย ตักน้ำหมักมาราดสลัดก็พร้อมเสิร์ฟแล้ว'
  ],
  portions: 2,
  tags: [ 'Sättigend', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'ซุปฮอร์สราดิชและบีทรูท',
  prev: 'rote_beete_suppe.jpg',
  time: '30 min.',
  ingredients: [
    'หัวหอม 1 ลูก',
    'มันหวาน 1 หัว',
    'บีทรูป 400 กรัม',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'น้ำเกลือ (หรือน้ำต้มผัก) 800 มล.',
    'น้ำส้มสายชูขาว 1 ช้อนโต๊ะ',
    undefined,
    'ฮอร์สราดิช 1 ช้อนโต๊ะ',
    'ครีมถั่วเหลือง 100 มก.',
    undefined
  ],
  preparation: [
    'ปอกหัวหอมและหั่นละเอียด ล้าง ปอก และสับมันฝรั่งกับบีทรูทอย่างละเอียด',
    'อุ่นน้ำมันมะกอกบนกระทะ เอาหัวหอมลงทอดซักครู่ จากนั้นเอามันฝรั่งและบีทรูปลงทอด ตัดมันด้วยน้ำเกลือ ปรุงรสด้วยเกลือพริกไทยน้ำส้มสายชู และยี่หร่า หาฝาปิดและเคี่ยวไว้ 20 นาที',
    'ใส่ฮอร์สราดิชจากนั้นเคี่ยวซุปด้วยเครื่องปั่น ใส่ครีมถั่วเหลืองเข้าไป 100 มล.'
  ],
  portions: 2,
  tags: [ 'Nährstoffreich', 'Lunch', 'Dinner', 'Vegan' ]
} ,
{
  name: 'เต้าหู้ไข่คน',
  prev: 'tofu_ruehrei.png',
  time: '15 min.',
  ingredients: [
    'เต้าหู้นิ่ม 200 กรัม',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'น้ำเปล่า 1 ช้อนโต๊ะ',
    'มะเขือเทศ 2 ลูก',
    'ต้นหอม 1 กล่อง',
    undefined,
    undefined
  ],
  preparation: [
    'ใช้ส้อมบี้เต้าหู้ ล้างมะเขือเทศและหัวหอม ตัดมะเขือเทศแบ่งครึ่ง ตัดหัวหอมเป็นแว่น',
    'ทอดเต้าหู้ประมาณ 3 นาที ใส่มะเขือเทศและหัวหอมลงไปทอดสักครู่ ปรุงรสด้วยขมิ้นเกลือ และพริกไทย'
  ],
  portions: 1,
  tags: [ 'Vegane Alternative', 'Breakfast', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'ซีเรียลอัลมอนด์กรุบกรอบ',
  prev: 'mandelmuesli.png',
  time: '10 min.',
  ingredients: [
    'อมาแรนท์คั่ว 20 กรัม',
    'ซีเรียลไม่หวาน 25 กรัม',
    'ข้าวโอ๊ต 40 กรัม',
    'อัลมอนด์คั่ว 15 กรัม',
    'บลูเบอร์รี่ 20 กรัม',
    'อัลมอนด์ 15 กรัม',
    'แครนเบอร์รี่ 20 กรัม',
    'เมล็ดแฟลกซ์ 1 ช้อนโต๊ะ',
    undefined,
    'นมอัลมอนด์ 200 มล.'
  ],
  preparation: [
    'ผสมอมาแรนท์คอร์นเฟล็คเกล็ดข้าวโอ๊ตอัลมอนด์คั่วและ อัลมอนด์เข้าด้วยกันในถ้วย',
    'ล้างเบอร์รี่ จากนั้นปลอกกล้วยแล้วตัดเป็นขนาดพอดีคำ ใส่ผลไม้ลงไปในถ้วยแล้วผสมกับวัตถุดิบอื่นๆ',
    'ใส่นมอัลมอนด์ลงในกราโนล่ากรอบ'
  ],
  portions: 1,
  tags: [ 'Mit Amaranth', 'Breakfast', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'มีตบอลกับซุปมันหวาน',
  prev: 'frikadellen_mit_suesskartoffel.jpg',
  time: '30 min.',
  ingredients: [
    'แครอท 400 กรัม',
    'มันหวาน 1 หัว',
    'เนื้อสับไขมันน้อย 300 กรัม',
    'นมเปรี้ยวไขมันต่ำ 2 ช้อนโต๊ะ',
    'เกล็ดขนมปังธัญพืช 2 ช้อนชา',
    'น้ำมันมะกอก 1 ช้อนโต๊ะ',
    'สมุนไพรสับละเอียด 3 ช้อนโต๊ะ',
    'นมไขมันต่ำ 3-4 ช้อนโต๊ะ',
    undefined
  ],
  preparation: [
    'ล้างและปอกปลอกแครอทและมันหวานแล้วตัดเป็นชิ้นเล็กๆ จากนั้นเอาลงกระทะ ใส่น้ำละลายเกลือและต้ม 15 นาที',
    'ในขณะเดียวกัน ปั้นเนื้อสับละเอียดเข้ากับนมเปรี้ยวไขมันต่ำเกล็ดขนมปังธัญพืชสมุนไพรเกลือและพริกไทย เพื่อปั้นมีตบอล 4 ลูก',
    'อุ่นน้ำมันมะกอกบนกระทะ ทอดมีตบอลด้วยความร้อนปานกลางจนมันกลายเป็นสีน้ำตาล',
    'สะเด็ดน้ำแครอทและมันฝรั่ง ใส่นมไขมันต่ำและปั่นละเอียด ปรุงรสด้วยเกลือและพริกไทย เสิร์ฟคู่กับมีตบอล'
  ],
  portions: 2,
  tags: [ 'Gesunde Alternative', 'Lunch' ]
} ,
{
  name: 'หอคอยบีทรูทกับอโวคาโดครีม',
  prev: 'rote_beete_tower.jpg',
  time: '20 min.',
  ingredients: [
    'บีทรูท 250 กรัม',
    'เต้าหู้ 300 กรัม',
    'น้ำมันมะกอก 3 ช้อนโต๊ะ',
    'น้ำเชื่อมอะกาเว 2 ช้อนชา',
    'กระเทียมสับละเอียด 1 หน่วย',
    'อะคาโด 3 ผล',
    'น้ำมะนาว 1 ช้อนโต๊ะ',
    undefined,
    undefined
  ],
  preparation: [
    'ล้างบีทรูทแล้วตัดเป็นชิ้นบางๆ ต้มน้ำใส่เกลือลงในหม้อเป็นเวลา 10 นาทีจนบีทรูทนุ่ม',
    'ตัดเต้าหู้เป็นชิ้นหนา 5 มม. แล้วใช้แก้วเล็กๆเป็นแบบตัดบีทรูทให้เป็นทรงกลม',
    'อุ่นน้ำมันมะกอกในกระทะแล้วทอดเต้าหู้ทั้งสองฝั่งประมาณ 3 นาที ปรุงรสด้วยเกลือและพริกไทย',
    'ปอกกระเทียวและสับละเอียด ล้างแล้วตัดแบ่งครึ่งอโวคาโดจากนั้นแกะเม็ดออก เพิ่มความเข้มข้นของอโวคาโดด้วยกระเทียวและน้ำมะนาว ปรุงรสด้วยเกลือและพริกไทย',
    'จัดวางเต้าหู้ บีทรูท และครีมอะโวคาโดเป็นชั้นๆตามใจชอบ โรยด้วยต้นเครซ'
  ],
  portions: 2,
  tags: [ 'Originelle Idee', 'Lunch', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'โคลราบิ ราวีโอลีพร้อมซอสมะเขือเทศและโหระพา',
  prev: 'kohlrabi_ravioli.jpg',
  time: '30 min.',
  ingredients: [
    '2 โคลราบิ',
    'น้ำมันมะกอก 6 ช้อนชา',
    'พริกแดง 1',
    undefined,
    'มะเขือเทศ 2 ลูก',
    undefined,
    'กระเทียมสองกลีบ',
    undefined
  ],
  preparation: [
    'ล้าง ปอกเปลือก แล้วฝานหรือหั่นโคลราบิให้ละเอียด ต้มน้ำเกลือในหม้อ นำออกจากความร้อนแล้วปล่อยให้โคลราบิหั่นละเอียดเคี่ยวเป็นเวลา 10 นาที ซับน้ำออกด้วยกระดาษทิชชู่ ผสมน้ำมันมะกอก 2 ช้อนโต๊ะกับเกลือหนึ่งหยิบมือในหม้อเล็ก ใส่โคลราบิข้างในแล้วหมัก',
    'ล้างพริก เอาเมล็ดออก แล้วหั่นเป็นชิ้นเล็ก ๆ ปอกเปลือกแล้วหั่นหัวหอมอย่างละเอียด อุ่นน้ำมันมะกอก 1 ช้อนชาในกระทะแล้วทอดประมาณ 1/3 ของชิ้นหัวหอมและปาปริก้าเป็นเวลา 5 นาที นำกระทะออกจากความร้อนแล้วคลุกเคล้ามะเขือเทศและหัวหอมด้วยส้อม ปรุงรสด้วยออรินาโน่ เกลือ และพริกไทย นำกระทะกลับมาตั้งบนเตาแล้วตั้งไฟให้ร้อน จนกว่าส่วนผสมจะเป็นครีม',
    'ในช่วงกลางของการหมักโคลราบิ เพิ่ม ส่วนผสมระหว่างปาปริก้ากับหัวหอม 1 ช้อนชา วางชิ้นโคลราบิที่สองข้างบนแล้วกดด้านข้างเล็กน้อย’',
    'ล้างและหั่นมะเขือเทศ ปอกและหั่นกลีบกระเทียมให้ละเอียดแล้วอุ่นน้ำมันมะกอกในกระทะ ผัดหัวหอมและกระเทียมที่เหลือประมาณ 2 นาที ใส่มะเขือเทศ พอผ่านไปสักพัก ใส่โหระพา ปรุงรสด้วยเกลือและพริกไทย.'
  ],
  portions: 2,
  tags: [ 'Gesunde Alternative', 'Lunch', 'Dinner', 'Vegan' ]
} ,
{
  name: 'ไอศกรีมช็อคโกแลตถั่วลิสง',
  prev: 'schoko_erdnuss_eis.jpg',
  time: '25 min.',
  ingredients: [
    'ถั่วลิสงบด 200 กรัม',
    'ก้อนน้ำแข็ง 250 กรัม',
    'ไซรัป Agave 65 กรัม',
    undefined,
    undefined,
    'โกโก้ 40 กรัม'
  ],
  preparation: [
    'ผสมถั่วลิสงบด ไซรัป Agave ก้อนน้ำแข็ง เกลือ และวานิลลาลงในเครื่องปั่น',
    'ผสมส่วนผสมครึ่งหนึ่งกับโกโก้ คนให้เข้ากันด้วยส้อมอีกครั้ง',
    'ใส่ไอศกรีมในชามตู้เย็นประมาณ 20 นาที'
  ],
  portions: 1,
  tags: [ 'Erfrischend', 'Snacks', 'Vegan' ]
} ,
{
  name: 'ไข่กับซอสมัสตาร์ด',
  prev: 'eier_senf.jpg',
  time: '25 min.',
  ingredients: [
    'ไข่ 4 ฟอง',
    'หนึ่งหัวหอมเล็ก',
    'นมไขมันต่ำ 50 มล.',
    'ผักชีลาว 2 ช้อนชา',
    'ชีสคอตเทจ 2 ช้อนโต๊ะ',
    'โยเกิร์ตไขมันต่ำ 2 ช้อนโต๊ะ',
    'มัสตาร์ดสามช้อนโต๊ะ',
    'น้ำมันมะกอก 1 ช้อนชา',
    undefined
  ],
  preparation: [
    'ต้มไข่เป็นเวลา 10 นาที',
    'ปอกเปลือกและหั่นหัวหอม',
    'อุ่นน้ำมันมะกอกในกระทะ ทอดก้อนหัวหอมจนกว่าจะใส',
    'ดีเกลซด้วยนม ผัดในชีสคอตเทจ โยเกิร์ต และมัสตาร์ต ต้มสักพัก',
    'ปอกเปลือกและหั่นไข่ต้มสุกครึ่งหนึ่ง เสิร์ฟพร้อมซอส'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'ซุปรากพาร์สลีย์',
  prev: 'petersiliensuppe.jpg',
  time: '30 min.',
  ingredients: [
    'รากพาร์สลีย์ 200 กรัม',
    'หอมแดง ½ ลูก',
    'กระเทียมสับละเอียด 1 หน่วย',
    'เนยแข็งคอตเทจ 200 กรัม',
    'พาร์สลีย์ ½ พวง',
    'น้ำ 250 มล.',
    'น้ำมันมะกอก 1 ช้อนชา',
    undefined
  ],
  preparation: [
    'ล้างรากพาร์สลีย์ หั่นครึ่งหนึ่งแล้วฝาน',
    'ปอกหัวหอมและกระเทียม หั่นลูกเต๋า',
    'อุ่นน้ำมันมะกอกในหม้อ ใส่รากพาร์สลีย์ หัวหอม และกระเทียมลูกเต๋าลงในหม้อแล้วทอดประมาณ 5 นาที',
    'เติมน้ำแล้วเคี่ยวเป็นเวลา 20 นาที',
    'ในระหว่างนี้ ล้าง สะเด็ดน้ำให้แห้ง แล้วหั่นพาร์สลีย์ ในตอนท้ายของการทำอาหาร ทำให้ซุปเข้มข้นด้วยมือ ผสมเข้ากับชีสคอตเทจแล้วโรยหน้าด้วยพาร์สลีย์'
  ],
  portions: 1,
  tags: [ 'Aromatisch', 'Lunch', 'Dinner', 'Snacks' ]
} ,
{
  name: 'สมูทตี้แครอทและแตงกวาดอง',
  prev: 'moere_gurken_smothie.jpg',
  time: '5 min.',
  ingredients: [
    'หนึ่งแตงกวาดอง',
    'น้ำแครอท 300 มล. (ไม่หวาน)',
    'ข้าวโอ๊ต 50 กรัม',
    'นมเปรี้ยวไขมันต่ำ 200 กรัม',
    'น้ำเปล่า 100 มล.'
  ],
  preparation: [
    'ล้างแตงกว่า ตัดเป็นชิ้นใหญ่ ๆ',
    'ใส่ส่วนผสมทั้งหมดลงในเครื่องปั่นแล้วปั่นจนกว่าจะได้เชคที่เนื้อละเอียด'
  ],
  portions: 1,
  tags: [ 'Mahlzeitersatz', 'Drink' ]
} 
]


// WEBPACK FOOTER //
// ./src/store/fitnes/modules/recipts/th.js